export default {
  common_share: `Bagikan`,
  common_share_short: `Bagikan`,
  common_notice: `Pemberitahuan`,
  common_notification: `Notifikasi`,
  common_download: `Unduh`,
  common_download_plural: `Unduh`,
  common_update: `Update`,
  common_update_now: `Update sekarang`,
  common_cancel: `Batal`,
  common_close: `Tutup`,
  common_ok: `Oke`,
  common_confirm: `Oke`,
  common_yes: `Ya`,
  common_no: `Tidak`,
  common_save: `Simpan`,
  common_error_retry: `Coba kembali`,
  common_login: `Masuk`,
  common_logout: `Keluar`,
  common_copy: `Salin`,
  common_refresh: `Refresh`,
  common_delete: `Hapus`,
  common_fix: `Edit`,
  common_service_version: `Versi aplikasi`,
  common_edit: `Edit`,
  common_language: `Bahasa`,
  common_language_english: `English`,
  common_language_korean: `한국어`,
  common_language_zh_hant: `繁體中文`,
  common_language_thai: `ภาษาไทย`,
  common_language_indonesia: `Indonesia`,
  common_language_french: `Français`,
  common_content_season: `Season `,
  common_content_season_plural: `Season `,
  common_content_episode: `Episode `,
  common_content_episode_plural: `Episode`,
  common_content_episode_value_short: `Ep. {{value}}`,
  common_episode_count: `{{count}} episode `,
  common_episode_count_plural: `{{count}} episode`,
  common_content_favorite: `Favorit`,
  common_content_tag: `Hashtag`,
  common_content_like: `Suka`,
  common_content_like_plural: `Suka`,
  common_universe: `Universe`,
  common_universe_circle: `Universe Circle`,
  common_viewer_alive: `ALIVE viewer`,
  common_matching_ai: `AI Matching`,
  common_matching_special: `Special matching`,
  common_free: `Gratis`,
  common_paid: `Berbayar`,
  common_rental: `Sewa`,
  common_gidamu: `Tunggu Gratis`,
  common_gidamu_plus: `{{value}}Jam`,
  common_gidamu_plus_long: `Tunggu gratis {{value}}Jam`,
  common_ongoing_free: `Gratis`,
  common_free_available: `Ep Gratis Tersedia`,
  common_now_charging: `Menunggu Ep Gratis`,
  common_tab_library: `Library`,
  common_tab_ranking: `Ranking`,
  common_tab_giftbox: `Hadiah`,
  common_tab_service_name: `KAKAO WEBTOON`,
  common_tab_time_table_global: `Jadwal`,
  common_tab_gidamu_plus: `Tunggu Gratis +`,
  common_cash: `Cash`,
  common_cash_amount: `{{value}} Cash`,
  common_cash_currency: `Rp{{value}}`,
  common_cash_currency_symbol: `Rp`,
  common_ticket_amount: `{{count}} Tiket`,
  common_ticket_amount_plural: `{{count}} Tiket`,
  common_cash_purchased: `Beli Cash`,
  common_cash_gift: `Event Cash`,
  common_ticket: `Tiket`,
  common_ticket_plural: `Tiket`,
  common_ticket_possession: `Tiket Permanen`,
  common_ticket_possession_plural: `Tiket Permanen`,
  common_ticket_possession_amount: `{{count}} Tiket Permanen`,
  common_ticket_possession_amount_plural: `{{count}} Tiket Permanen`,
  common_ticket_rental: `Tiket Sewa`,
  common_ticket_rental_plural: `Tiket Sewa`,
  common_ticket_rental_amount: `{{count}} Tiket Sewa`,
  common_ticket_rental_amount_plural: `{{count}} Tiket Sewa`,
  common_ticket_gift: `Tiket Hadiah`,
  common_ticket_gift_plural: `Tiket Hadiah`,
  common_ticket_gift_amount: `{{count}} Tiket Hadiah`,
  common_ticket_gift_amount_plural: `{{count}} Tiket Hadiah`,
  common_ticket_gidamu: `Tiket Tunggu Gratis`,
  common_ticket_gidamu_plural: `Tiket Tunggu Gratis`,
  common_ticket_gidamu_amount: `{{count}} Tiket Tunggu Gratis`,
  common_ticket_gidamu_amount_plural: `{{count}} Tiket Tunggu Gratis`,
  common_expired: `Kedaluwarsa`,
  common_add: `Tambahkan`,
  common_purchase: `Beli`,
  common_refund: `Refund`,
  common_refund_past: `Telah di-refund`,
  common_use: `Gunakan`,
  common_use_past: `Telah digunakan`,
  common_purchased: `Beli Permanen`,
  common_crm_slot_ticket: `Tiket Lucky Draw`,
  common_crm_slot_ticket_plural: `Tiket Lucky Draw`,
  common_crm_reservation: `Pra-registrasi`,
  common_bm_gidamu: `Tunggu Gratis`,
  common_bm_preview: `Preview`,
  common_genre_all: `Semua`,
  common_genre_romance: `Romansa`,
  common_genre_romance_fantasy: `Romansa Fantasi`,
  common_genre_comedy: `Komedi`,
  common_genre_action: `Aksi`,
  common_genre_fantasy: `Fantasi`,
  common_genre_thriller_horror: `Thriller/Horor`,
  common_genre_bl: `BL/GL`,
  common_genre_drama: `Drama`,
  common_schedule_daily: `Daily`,
  common_schedule_new: `New`,
  common_schedule_mon: `Sen`,
  common_schedule_tue: `Sel`,
  common_schedule_wed: `Rab`,
  common_schedule_thu: `Kam`,
  common_schedule_fri: `Jum`,
  common_schedule_sat: `Sab`,
  common_schedule_sun: `Min`,
  common_schedule_completed: `End`,
  common_time_year_ago: `{{count}} tahun yang lalu`,
  common_time_year_ago_plural: `{{count}} tahun yang lalu`,
  common_time_month_ago: `{{count}} bulan yang lalu`,
  common_time_month_ago_plural: `{{count}} bulan yang lalu`,
  common_time_day_ago: `{{count}} hari yang lalu`,
  common_time_day_ago_plural: `{{count}} hari yang lalu`,
  common_time_hour_ago: `{{count}} jam yang lalu`,
  common_time_hour_ago_plural: `{{count}} jam yang lalu`,
  common_time_minute_ago: `{{count}} menit yang lalu`,
  common_time_minute_ago_plural: `{{count}} menit yang lalu`,
  common_time_second_ago: `Baru saja`,
  common_now: `Sekarang`,
  common_period_year: `{{count}} tahun`,
  common_period_year_plural: `{{count}} tahun`,
  common_period_month: `{{count}} bulan`,
  common_period_month_plural: `{{count}} bulan`,
  common_period_day: `{{count}} hari`,
  common_period_day_plural: `{{count}} hari`,
  common_period_hour: `{{count}} jam`,
  common_period_hour_plural: `{{count}} jam`,
  common_period_minute: `{{count}} menit`,
  common_period_minute_plural: `{{count}} menit`,
  common_period_year_short: `{{count}} tahun`,
  common_period_year_short_plural: `{{count}} tahun`,
  common_period_month_short: `{{count}} bulan`,
  common_period_month_short_plural: `{{count}} bulan`,
  common_period_day_short: `{{count}} hari`,
  common_period_day_short_plural: `{{count}} hari`,
  common_period_hour_short: `{{count}} jam`,
  common_period_hour_short_plural: `{{count}} jam`,
  common_period_minute_short: `{{count}} menit`,
  common_period_minute_short_plural: `{{count}} menit`,
  common_period_second_short: `{{count}} detik`,
  common_period_second_short_plural: `{{count}} detik`,
  common_time_left: `Sisa {{value}}`,
  common_time_ago: `{{value}} yang lalu`,
  common_stroage_kb: `{{value}} KB`,
  common_stroage_mb: `{{value}} MB`,
  common_stroage_gb: `{{value}} GB`,
  common_service_name: `KAKAO WEBTOON`,
  common_not_select: `Tidak ada pengaturan`,
  common_kakaowebtoon: `KAKAO WEBTOON`,
  common_tab_home: `Beranda`,
  recomm_tab_recommendations: `Rekomendasi`,
  recomm_tab_special: `Spesial`,
  recomm_tab_gidamu: `Tunggu Gratis +`,
  recomm_top_100: `TOP 100`,
  recomm_tab_gidamu_description: `Setiap {{hour}} jam sekali <grey-bold> akan mendapat Tiket Tunggu Gratis </grey-bold>. 
Daftar karya sering berubah, ayo baca sekarang!`,
  recomm_label_gidamu: `Gratis setiap {{value}} jam`,
  top_guide_popup: `Cek lebih detail mengenai
notifikasi Tunggu Gratis`,
  recomm_label_popular: `Terpopuler`,
  recomm_label_completed_nearly: `Segera Tamat`,
  recomm_label_completed_nearly_detail: `Akan tamat pada`,
  recomm_label_upcoming: `Yang akan datang`,
  recomm_label_trailer: `Trailer film`,
  recomm_label_original_movie: `Film original`,
  recomm_label_original_drama: `Drama original`,
  recomm_label_event: `Event`,
  recomm_label_event_detail_gift: `Cash Hadiah`,
  recomm_label_event_detail_max: `maksimal`,
  recomm_label_ticket_detail: `{{value}}`,
  recomm_label_ticket_detail_v4: `{{value}} Tiket diperoleh`,
  recomm_label_ticket_detail_gift: `Tiket Hadiah`,
  recomm_label_legend: `Legend`,
  recomm_label_new_detail: `dilihat`,
  recomm_label_popular_detail: `Total dilihat`,
  recomm_label_recommendation: `Rekomendasi AI`,
  common_tab_top: `HOME`,
  common_tab_hot: `Sedang Populer`,
  ranking_tab_weekly: `Mingguan`,
  ranking_tab_daily: `Harian`,
  ranking_tab_real_time: `Terkini`,
  ranking_in_progress: `Penghitungan ranking sedang berlangsung`,
  ranking_badge_new: `N`,
  ranking_criteria_popup_title: `Kriteria sortir peringkat`,
  ranking_criteria_popup_contents: `Semua peringkat di KAKAO WEBTOON didasarkan pada statistik per jam, 
berdasarkan data pengguna seperti data buka halaman dan pembelian`,
  common_tab_category: `Discover`,
  category_tab_ranking: `Ranking`,
  category_tab_ranking_weekly: `Mingguan`,
  category_tab_ranking_daily: `Harian`,
  category_tab_ranking_real_time: `Saat ini`,
  category_tab_ranking_in_progress: `Penghitungan ranking sedang berlangsung`,
  category_tab_ranking_badge_new: `N`,
  category_tab_new: `New`,
  category_tab_ongoing: `Ongoing`,
  category_tab_completed: `End`,
  common_tab_original_webtoon: `Webtoon Original`,
  common_tab_original_novel: `Novel Original`,
  schedule_new_today: `Hari ini`,
  schedule_genre_filter_all: `Semua`,
  schedule_monday: `Senin`,
  schedule_tuesday: `Selasa`,
  schedule_wednesday: `Rabu`,
  schedule_thursday: `Kamis`,
  schedule_friday: `Jumat`,
  schedule_saturday: `Sabtu `,
  schedule_sunday: `Minggu`,
  schedule_empty: `Tidak ada karya`,
  schedule_completed_label_legend: `Legend`,
  schedule_completed_label_pd: `Rekomendasi Editor`,
  schedule_completed_label_trailer: `Trailer film`,
  schedule_completed_label_recommendation: `Rekomendasi`,
  schedule_completed_label_magazine: `Majalah`,
  schedule_completed_label_cashback: `Cashback`,
  schedule_two_column: `Lihat 2 baris`,
  schedule_three_column: `Lihat 3 baris`,
  schedule_four_column: `Lihat 4 baris`,
  schedule_two_column_selected: `Lihat 2 baris`,
  schedule_three_column_selected: `Lihat 3 baris`,
  schedule_four_column_selected: `Lihat 4 baris`,
  schedule_sort_guide: `Kumpulan karya berdasarkan hari.
Urutkan berdasarkan keinginanmu`,
  schedule_guide_popup: `Kamu dapat mengatur urutan dan jenis daftar`,
  schedule_sort_title: `Menyotir`,
  schedule_sort_recommend: `Rekomendasi`,
  schedule_sort_early_access: `Jumlah episode gratis`,
  schedule_sort_gidamu: `Jumlah episode Tunggu Gratis`,
  schedule_sort_gidamu_short: `Waktu Tunggu Gratis pendek`,
  schedule_sort_not_provided_toast: `Saat ini hanya dapat mengurutkan berdasarkan rekomendasi.`,
  schedule_genre_select_popup: `Pilih genre`,
  login_action_view_next_episode_popup: `Harus Masuk untuk 
membaca episode berikutnya`,
  contenthome_wifi_popup: `Tidak tersambung ke Wi-Fi. Mau pakai paket data selulermu untuk baca episode?`,
  contenthome_ticketused_possession_snackbar: `{{value}} Tiket Permanen terpakai.`,
  contenthome_ticketused_rental_snackbar: `{{value}} Tiket Sewa terpakai.`,
  contenthome_ticketused_gift_snackbar: `{{value}} Tiket Hadiah terpakai.`,
  contenthome_ticketused_gidamu_snackbar: `{{value}} Tiket Tunggu Gratis terpakai`,
  contenthome_ticket_option_popup: `Mohon pilih Tiket yang akan digunakan`,
  contenthome_popup_rent_button: `Sewa`,
  contenthome_popup_possess_button: `Permanen`,
  contenthome_ticket_remaining: `Sewa: {{rental}} Tiket / Permanen: {{possess}} Tiket`,
  contenthome_ticket_remaining_rental_plural: `Sewa: {{rental}} Tiket / Permanen: {{possess}} Tiket`,
  contenthome_ticket_remaining_possession_plural: `Sewa: {{rental}} Tiket / Permanen: {{possess}} Tiket`,
  contenthome_ticket_remaining_plural: `Sewa: {{rental}} Tiket / Permanen: {{possess}} Tiket`,
  contenthome_popup_ticket_rental: `Sewa: {{count}} Tiket`,
  contenthome_popup_ticket_rental_plural: `Sewa: {{count}} Tiket`,
  contenthome_popup_ticket_possession: `Permanen: {{count}} Tiket`,
  contenthome_popup_ticket_possession_plural: `Permanen: {{count}} Tiket`,
  contenthome_latest_ep_ticket_popup: `{{value}} episode terbaru tidak dapat menggunakan Tiket Tunggu Gratis. 
Apakah kamu  mau menggunakan Tiket lainnya?`,
  contenthome_latest_ep_ticket_rental_popup: `{{value}} episode terbaru tidak dapat menggunakan Tiket Tunggu Gratis. 
Apakah kamu mau menggunakan Tiket Sewa?`,
  contenthome_latest_ep_ticket_possession_popup: `{{value}} episode terbaru tidak dapat menggunakan Tiket Tunggu Gratis. 
Apakah kamu mau menggunakan Tiket Permanen?`,
  contenthome_not_gidamu_ep_ticket_popup: `Episode ini tidak dapat dibaca dengan Tiket Tunggu Gratis. 
Apakah kamu mau menggunakan Tiket lainnya?`,
  contenthome_not_gidamu_ep_ticket_rental_popup: `Episode ini tidak dapat dibaca dengan Tiket Tunggu Gratis. 
Apakah kamu mau menggunakan Tiket Sewa?`,
  contenthome_not_gidamu_ep_ticket_possession_popup: `Episode ini tidak dapat dibaca dengan Tiket Tunggu Gratis. 
Apakah kamu mau menggunakan Tiket Permanen?`,
  contenthome_rented_ep_ticket_rental_popup: `Kamu telah menyewa episode ini sebelumnya. Apakah kamu mau menggunakan Tiket Sewa?`,
  contenthome_rented_ep_ticket_possession_popup: `Kamu telah menyewa episode ini sebelumnya. Apakah kamu mau menggunakan Tiket Permanen?`,
  contenthome_rented_ep_ticket_gift_popup: `Kamu pernah sewa episode ini sebelumnya.
Tiket hadiah akan di gunakan.`,
  contenthome_rented_ep_ticket_gidamu_popup: `Kamu pernah sewa episode ini sebelumnya.
Tiket Tunggu Gratis akan di gunakan.`,
  contenthome_rented_ep_ticket_popup: `Kamu telah membaca episode ini sebelumnya. Apakah kamu mau menggunakan Tiket?`,
  contenthome_rented_ep_purchase_ticket_popup: `Kamu telah membaca episode ini sebelumnya. Apakah kamu mau membeli Tiket?`,
  contenthome_expired_popup: `Tidak bisa lanjut baca karena masa sewa sudah kedaluwarsa. Silakan pilih episode selanjutnya untuk dibaca.`,
  contenthome_expired_popup_viewed_button: `Episode yang terakhir dibaca`,
  contenthome_expired_popup_next_button: `Episode selanjutnya`,
  contenthome_latest_expired_ticket_rental_popup: `{{value}} episode terbaru yang pernah
disewa tidak dapat dibeli dengan
 Tiket Tunggu Gratis. 
Apakah kamu mau 
menggunakan Tiket Sewa?`,
  contenthome_latest_expired_ticket_possession_popup: `{{value}} episode terbaru yang
pernah disewa tidak dapat 
dibeli dengan Tiket Tunggu Gratis. 
Apakah kamu mau 
menggunakan Tiket Permanen?`,
  contenthome_latest_expired_ticket_popup: `{{value}} episode terbaru yang pernah disewa tidak dapat dibeli dengan Tiket Tunggu Gratis. Apakah kamu mau menggunakan Tiket lainnya?`,
  contenthome_stop_sell_popup: `Karya ini tidak dapat dibeli.`,
  contenthome_ticketused_gift_popup: `Tiket Hadiah akan digunakan.`,
  contenthome_ticketused_rental_popup: `Tiket Sewa akan digunakan.`,
  contenthome_ticketused_possession_popup: `Tiket Permanen akan digunakan.`,
  contenthome_ticketused_gidamu_popup: `Tiket Tunggu Gratis akan digunakan.`,
  contenthome_latest_ep_gidamu_popup: `Karya ini tidak dapat di baca dengan Tiket Tunggu Gratis.`,
  contenthome_universe_matching: `{{matching}} selain dengan {{title}}`,
  contenthome_universe_similar_title: `Judul yang serupa`,
  contenthome_universe_similar_drawing: `Gambar yang serupa`,
  contenthome_universe_same_genre: `{{genre}} judul`,
  contenthome_universe_today_popular: `Karya terpopuler hari ini`,
  contenthome_universe_today_favorite: `Karya terfavorit hari ini`,
  contenthome_gift_rental_popup: `Menerima {{count}} Tiket Hadiah`,
  contenthome_gift_rental_popup_plural: `Menerima {{count}} Tiket Hadiah`,
  contenthome_gift_rental_valid_until_popup: `Kedaluwarsa: 3 hari setelah diterima`,
  contenthome_expiry_specific_date: `Berlaku sampai {{value}}`,
  contenthome_fav_notification_popup_title: `Telah ditambahkan ke Favorit`,
  contenthome_fav_notification_popup_content: `Kamu akan menerima notifikasi ketika episode baru rilis.
Notifikasi dapat diatur di 'Library > Favoritku'.`,
  contenthome_fav_undo_toast: `Hapus dari Favorit`,
  contenthome_ticketbar_ticket: `{{count}} Tiket`,
  contenthome_ticketbar_ticket_plural: `{{count}} Tiket`,
  contenthome_ticketbar_newbie_ticket: `Benefit User Baru {{count}} Tiket`,
  contenthome_ticketbar_newbie_ticket_plural: `Benefit User Baru {{count}} Tiket`,
  contenthome_ticketbar_gidamu: `Gratis setiap {{count}} hari`,
  contenthome_ticketbar_gidamu_plural: `Gratis setiap {{count}} hari`,
  contenthome_ticketbar_gidamu_hour: `Gratis setiap {{count}} jam`,
  contenthome_ticketbar_gidamu_hour_plural: `Gratis setiap {{count}} jam`,
  contenthome_ticketbar_gidamu_minute: `Gratis setiap {{count}} menit`,
  contenthome_ticketbar_gidamu_minute_plural: `Gratis setiap {{count}} menit`,
  contenthome_ticketbar_gidamu_full: `Episode gratis siap dibaca`,
  contenthome_ticketbar_ep_free: `Gratis {{count}} episode`,
  contenthome_ticketbar_ep_free_plural: `Gratis {{count}} episode`,
  contenthome_ticketbar_all_free: `Gratis semua episode `,
  contenthome_ticketbar_charged: `Tiket Tunggu Gratis tersedia`,
  contenthome_ticketbar_charging: `Gratis setelah {{value}}`,
  contenthome_ticketbar_preview: `Preview {{count}} episode`,
  contenthome_ticketbar_preview_plural: `Preview {{count}} episode`,
  contenthome_ticketbar_unavailable: `Penjualan dihentikan`,
  contenthome_guide_popup: `Geser ke kanan untuk melihat karya yang sesuai,
geser ke bawah untuk melihat koleksi yang sesuai.`,
  contenthome_total: `Semua`,
  contenthome_first_episode_tab_button: `Baca Ep Pertama`,
  contenthome_first_episode_tab_continue: `Lanjut baca Ep Pertama`,
  contenthome_first_episode_tab_guide: `Tombol baca episode pertama
akan berubah menjadi lanjut baca episode
setelah mulai membaca episode pertama.`,
  contenthome_first_episode_tab_content: `Penasaran bagaimana kelanjutannya?`,
  contenthome_first_episode_tab_page_only: `Karya ini hanya bisa dibaca pada
mode page view. Apakah kamu ingin
beralih ke page view?`,
  contenthome_first_episode_tab_paid: `Episode berbayar.
Apakah kamu ingin menggunakan Tiket?`,
  contenthome_first_episode_tab_stop_sell: `Karya ini sudah tidak tersedia untuk dibeli.`,
  contenthome_first_episode_tab_related_novel: `Baca web novel terkait`,
  contenthome_first_episode_tab_viewer: `Lihat lebih lanjut`,
  contenthome_continue_episode_tab_last_read: `Episode ini sudah dilihat {{value}} hari yang lalu.`,
  contenthome_continue_episode_tab_last_episode: `Ini adalah episode terakhir.`,
  contenthome_continue_episode_tab_stop_sell: `Episode ini sudah tidak tersedia untuk dibeli.`,
  contenthome_continue_next_episode: `Baca selanjutnya {{value}}`,
  contenthome_continue_last_episode: `Tidak ada episode berikutnya.`,
  contenthome_episode_tab_button: `Episode`,
  contenthome_preview_day: `{{count}} hari lagi gratis`,
  contenthome_preview_day_plural: `{{count}} hari lagi gratis`,
  contenthome_ep_tab_order_latest_snackbar: `Urutkan dari yang terbaru`,
  contenthome_ep_tab_order_chronological_snackbar: `Urutkan berdasarkan tanggal`,
  contenthome_ep_tab_first_episode_button: `Baca Episode Pertama`,
  contenthome_ep_tab_continue_episode_button: `Lanjut baca {{value}}`,
  contenthome_ep_tab_continue_without_episode_button: `Lanjut baca`,
  contenthome_ep_tab_back_top_button: `Kembali ke atas`,
  contenthome_alive_unzipping: `Mengelola file...`,
  contenthome_alive_download_popup_title: `ALIVE adalah tipe tampilan webtoon terbaru. Nikmati dengan fitur suara.`,
  contenthome_storage_full_popup_title: `Ruang penyimpanan tidak cukup.`,
  contenthome_storage_full_popup_content: `Silakan ulangi kembali setelah ruang penyimpananmu cukup`,
  contenthome_alive_fail_unzip_popup_title: `Tidak dapat membuka/mengekstrak zip file`,
  contenthome_alive_fail_unzip_popup_content: `Silakan unduh file-nya.`,
  contenthome_ep_tab_stop_sell_popup: `Tidak bisa dibaca karena penjualan ditangguhkan.`,
  contenthome_ep_expired: `Masa sewa telah berakhir`,
  contenthome_ep_tab_type_thumbnail: `Jenis Thumbnail`,
  contenthome_ep_tab_type_list: `Jenis view`,
  contenthome_ep_tab_order_latest: `Urutkan ep terbaru`,
  contenthome_ep_tab_order_chronological: `Diurutkan dari awal`,
  contenthome_ep_tab_type_thumbnail_toast: `Ditampilkan dengan mode thumbnail.`,
  contenthome_ep_tab_type_list_toast: `Ditampilkan dengan mode list`,
  contenthome_ep_tab_download_guide_popup: `Hanya dapat mengunduh dengan mode list`,
  contenthome_ep_tab_type_popup_title: `Berikut daftar list yang 
dapat digunakan untuk 
mengunduh dan membaca.`,
  contenthome_info_tab_button: `Informasi`,
  contenthome_info_tab_author: `Penulis`,
  contenthome_info_tab_illustrator: `Gambar `,
  contenthome_info_tab_original: `Karya
Asli`,
  contenthome_info_tab_adaptation: `Penyadur`,
  contenthome_info_tab_color: `Warna`,
  contenthome_info_tab_publisher: `Penerbit`,
  contenthome_info_tab_summary: `Sinopsis`,
  contenthome_info_tab_more_button: `Lihat lebih lanjut`,
  contenthome_info_tab_keywords: `Kata kunci`,
  contenthome_info_tab_video: `Video`,
  contenthome_info_tab_video_v4: `Video terkait`,
  contenthome_info_tab_teaser: `Video Teaser`,
  contenthome_info_tab_special: `Special `,
  contenthome_info_tab_rec_author: `Karya lain dari {{author}}`,
  viewer_end_recommendation: `Karya serupa`,
  contenthome_ticket_tab_button: `Tiket`,
  contenthome_ticket_tab_gift_ticket_1: `EVENT`,
  contenthome_ticket_tab_gift_ticket_2: `Tiket Gratis {{value}}`,
  contenthome_ticket_tab_gift_ticket_button: `Terima`,
  contenthome_ticket_tab_gift_ticket_remaining: `Sisa Tiket`,
  contenthome_ticket_tab_ticket_purchase_button: `Pembelian`,
  contenthome_ticket_tab_ticket_history: `Riwayat Tiket`,
  contenthome_ticket_tab_ticket_count: `{{count}} Tiket`,
  contenthome_ticket_tab_ticket_count_plural: `{{count}} Tiket`,
  contenthome_comment_tab_button: `Komentar`,
  comment_order_recent_snackbar: `Urutkan dari yang terbaru`,
  comment_order_likes_snackbar: `Urutkan dari jumlah likes`,
  comment_order_recent: `Terbaru`,
  comment_order_likes: `Terpopuler`,
  contenthome_comment_empty: `Tidak ada komentar`,
  contenthome_tickethistory: `Riwayat Tiket`,
  contenthome_sidemenu_notice: `Pemberitahuan`,
  contenthome_sidemenu_clearhistory: `Hapus riwayat bacaan`,
  contenthome_sidemenu_share: `Bagikan`,
  share_popup_title: `Bagikan`,
  share_link_copied_paste_toast: `Link tersalin ke clipboard.
Tempelkan link di mana pun.`,
  contenthome_sidemenu_download_autodelete: `Episode yang telah terunduh akan otomatis terhapus setelah kedaluwarsa. Atur di 'Library > Unduh'`,
  contenthome_sidemenu_download_available: `Bisa diunduh`,
  contenthome_sidemenu_download_waiting: `Tunggu untuk mengunduh`,
  contenthome_sidemenu_download_complete: `Unduh selesai`,
  contenthome_sidemenu_download_purchase: `Unduh setelah membeli`,
  contenthome_sidemenu_download_fail: `Unduh gagal`,
  contenthome_sidemenu_register_popup_title: `Apakah kamu mau mendaftarkan perangkat yang kamu gunakan saat ini?`,
  contenthome_sidemenu_register_popup_content: `Pendaftaran perangkat diperlukan untuk mengunduh episode, perangkatmu saat ini tidak terdaftar. 
Hanya 2 perangkat per ID yang dapat didaftarkan, 
dan penggantian perangkat dapat dilakukan satu bulan sekali.`,
  settings_device_register_impossible_exceed_popup_title: `Tidak dapat mendaftarkan perangkat 
karena jumlah pembatalan pendaftaran 
sudah terlampaui.`,
  settings_device_register_impossible_exceed_popup_content: `Pendaftaran perangkat hanya dapat dilakukan satu bulan sekali.`,
  settings_device_register_exceed_popup: `Jumlah perangkat yang terdaftar sudah terlampaui. Batalkan perangkat yang sudah terdaftar untuk mendaftarkan perangkat baru.`,
  settings_device: `Pengaturan perangkat`,
  contenthome_sidemenu_download_data_popup_title: `Apakah kamu yakin menggunakan data seluler untuk mengunduh?`,
  contenthome_sidemenu_download_data_popup_content: `Kamu sedang tidak terhubung dengan jaringan Wi-Fi. Kamu mungkin akan dikenakan tarif sesuai dengan penggunaan data selulermu.`,
  contenthome_sidemenu_download_complete_popup_title: `{{title}} selesai diunduh`,
  contenthome_sidemenu_download_complete_popup_content: `{{episode}} telah diunduh`,
  contenthome_sidemenu_download_complete_popup_content_plural: `{{count}} episode telah diunduh.`,
  contenthome_sidemenu_download_fail_popup_title: `{{title}} gagal diunduh.`,
  contenthome_sidemenu_download_fail_popup_content: `Gagal mengunduh {{episode}}.`,
  contenthome_sidemenu_download_fail_popup_content_plural: `Gagal mengunduh {{count}} episode.`,
  notification_notice_list_blank: `Tidak ada pemberitahuan`,
  contenthome_sidemenu_clearhistory_deleted: `Riwayat yang pernah dilihat olehmu telah dihapus`,
  contenthome_universe_matching_exploring: `Jelajahi`,
  contenthome_universe_matching_type_ai: `AI Matching`,
  contenthome_universe_title: `{{title}}`,
  contenthome_universe_matching_type_ai_similar: `Karya yang serupa dengan {{title}}`,
  contenthome_universe_matching_type_ai_drawing: `Gambar yang serupa dengan {{title}}`,
  contenthome_universe_matching_type_ai_genre: `{{genre}} yang serupa 
dengan genre {{title}}`,
  contenthome_universe_matching_type_special: `Special matching`,
  contenthome_universe_matching_type_special_other: `{{matching}} selain dengan {{title}}`,
  contenthome_universe_matching_type_today: `Today's matching`,
  contenthome_universe_matching_type_today_mostviewed: `Karya paling banyak dilihat hari ini`,
  contenthome_universe_matching_type_today_mostpopular: `Karya terfavorit hari ini`,
  contenthome_universe_matching_type_nextup: `{{type}} lainnya`,
  contenthome_universe_matching_blank: `Tidak ada hasil universe yang cocok `,
  contenthome_universe_matching_first: `Karya pertama.`,
  contenthome_universe_matching_last: `Karya terakhir.`,
  contenthome_stop_sell_refund_popup: `Karya ini sudah tidak tersedia untuk dibeli. Apakah kamu mau me-refund atau batal menggunakan Tiket-mu?`,
  contenthome_stop_sell_toast: `Penjualan karya ini telah dihentikan.`,
  contenthome_prohibited_sell_popup: `Karya ini tidak dapat dibaca karena penjualannya ditangguhkan.`,
  contenthome_tickethistory_purchased: `Telah dibeli`,
  contenthome_tickethistory_used: `Telah digunakan`,
  contenthome_tickethistory_gidamu_minute: `Gratis setiap {{count}} menit`,
  contenthome_tickethistory_gidamu_minute_plural: `Gratis setiap {{count}} menit`,
  contenthome_tickethistory_gidamu_day: `Gratis setiap {{count}} hari`,
  contenthome_tickethistory_gidamu_day_plural: `Gratis setiap {{count}} hari`,
  contenthome_tickethistory_gidamu_hour: `Gratis setiap {{count}} jam`,
  contenthome_tickethistory_gidamu_hour_plural: `Gratis setiap {{count}} jam`,
  contenthome_tickethistory_popup_detail_minute_1: `Setelah menggunakan Tiket Tunggu Gratis, tunggu {{count}} menit lagi untuk mendapatkan 1 Tiket Tunggu Gratis berikutnya.`,
  contenthome_tickethistory_popup_detail_minute_1_plural: `Setelah menggunakan Tiket Tunggu Gratis, tunggu {{count}} menit lagi untuk mendapatkan 1 Tiket Tunggu Gratis berikutnya.`,
  contenthome_tickethistory_popup_detail_hour_1: `Kamu bisa menerima Tiket lainnya {{count}} jam setelah menggunakan Tiket Tunggu Gratis`,
  contenthome_tickethistory_popup_detail_hour_1_plural: `Kamu bisa menerima Tiket lainnya {{count}} jam setelah menggunakan Tiket Tunggu Gratis`,
  contenthome_tickethistory_popup_detail_day_1: `Kamu bisa menerima Tiket lainnya {{count}} hari setelah menggunakan Tiket Tunggu Gratis`,
  contenthome_tickethistory_popup_detail_day_1_plural: `Kamu bisa menerima Tiket lainnya {{count}} hari setelah menggunakan Tiket Tunggu Gratis`,
  contenthome_tickethistory_popup_detail_2: `{{value}} episode terbaru (termasuk episode gratis) tidak termasuk 'Tunggu Gratis'.`,
  contenthome_tickethistory_popup_detail_3: `Episode yang telah dibeli menggunakan Tiket Tunggu Gratis berlaku selama 3 hari`,
  contenthome_tickethistory_gift_event: `Hadiah Event`,
  ticket_history_used_newbie: `Benefit User Baru`,
  contenthome_tickethistory_cancelled: `Dibatalkan`,
  contenthome_tickethistory_refund_title: `Batalkan pembelian Tiket`,
  contenthome_tickethistory_refund_purchase_info: `Informasi Pembelian`,
  contenthome_tickethistory_refund_purchase_info_date: `Tanggal pembelian`,
  contenthome_tickethistory_refund_purchase_info_number: `Nomor Invoice`,
  contenthome_tickethistory_refund_purchase_info_ticket: `Jumlah Tiket yang dibeli`,
  contenthome_tickethistory_refund_purchase_info_ticket_plural: `Jumlah Tiket yang dibeli`,
  contenthome_tickethistory_refund_purchase_info_ticket_bonus: `{{count}} Tiket + {{bonus}} Tiket`,
  contenthome_tickethistory_refund_purchase_info_ticket_bonus_plural: `{{count}} Tiket + {{bonus}} Tiket`,
  contenthome_tickethistory_refund_info: `Informasi Refund`,
  contenthome_tickethistory_refund_info_ticket: `Jumlah Tiket yang dapat di-refund`,
  contenthome_tickethistory_refund_info_ticket_cash: `Harga Cash per Tiket`,
  contenthome_tickethistory_refund_info_cash: `Refund Cash`,
  contenthome_tickethistory_refund_info_cash_expired: `Event Cash yang telah kedaluwarsa`,
  contenthome_tickethistory_refund_info_cash_able: `Cash yang dapat di-refund`,
  contenthome_tickethistory_refund_notice_price: `Pemberitahuan Perihal Refund`,
  contenthome_tickethistory_refund_notice_price_1: `Berikut adalah jumlah yang bisa kamu batalkan, tidak termasuk Event Cash yang sudah kedaluwarsa.`,
  contenthome_tickethistory_refund_notice_price_2: `Masing-masing dari jumlah yang dibatalkan, riwayat Tiket, dan riwayat transaksi mungkin berbeda menurut informasi Event Cash yang telah kedaluwarsa.`,
  contenthome_tickethistory_refund_notice_policy: `Kebijakan Refund`,
  contenthome_tickethistory_refund_notice_policy_1: `Pembelian Tiket dengan menggunakan Event Cash hanya dapat di-refund sampai masa berlaku Event Cash tersebut.`,
  contenthome_tickethistory_refund_notice_policy_2: `Tiket Hadiah yang berasal dari 'Tiket Hadiah Hari Ini', 'Benefit User Baru', dan 'Tiket Bonus' tidak dapat di-refund. `,
  contenthome_tickethistory_refund_notice_policy_3: `Tiket hanya dapat di-refund dalam bentuk Kakao Webtoon Cash.`,
  contenthome_tickethistory_refund_notice_policy_4: `Harap proses dengan hati-hati karena pembatalan pembelian Tiket tidak dapat dibatalkan.`,
  contenthome_tickethistory_refund_notice_policy_5: `Silakan hubungi Customer Service kami untuk me-refund Cash`,
  contenthome_tickethistory_refund_button: `Batal beli Tiket`,
  contenthome_tickethistory_refund_popup: `Apakah kamu yakin akan membatalkan pembelian Tiket?`,
  contenthome_tickethistory_refund_detail_popup: `Tiket yang dibatalkan: {{ticket}} Tiket / 
Jumlah yang di-refund: {{cash}} Cash`,
  contenthome_tickethistory_refund_detail_popup_plural: `Tiket yang dibatalkan: {{ticket}} Tiket / 
Jumlah yang di-refund: {{cash}} Cash`,
  contenthome_tickethistory_refund_snackbar: `Pembelian Tiket dibatalkan`,
  contenthome_tickethistory_used_gift_event: `Tiket Hadiah (Hadiah Event)`,
  contenthome_tickethistory_used_gift_newbie: `Tiket Hadiah (Benefit User Baru)`,
  gift_ticket_fail_received_popup: `Kamu telah menerima hadiahmu.`,
  gift_ticket_fail_expired_popup: `Telah kedaluwarsa`,
  viewer_capture_aos_snackbar: `Screenshot tidak diperbolehkan karena kebijakan keamanan.`,
  viewer_capture_ios_popup_title: `Peringatan perlindungan hak cipta`,
  viewer_capture_ios_popup_content: `Membagi dan menyebarkan screenshot tanpa izin dapat dikenakan sanksi hukum. Semua riwayat screenshot/tangkapan layar dapat dicek melalui sistem, dan akan dikenakan sanksi hukum jika pendistribusian konten terkonfirmasi.`,
  viewer_record_snackbar: `Merekam layar tidak diperbolehkan karena kebijakan keamanan.`,
  viewer_stop_sale_popup: `Tidak bisa melihat episode yang sudah ditutup.`,
  viewer_related_novel: `Baca web novel terkait`,
  contenthome_alive_download_popup_content: `Dapat dibaca setelah diunduh.
Direkomendasikan untuk menggunakan jaringan Wi-Fi`,
  viewer_marathon_viewing_snackbar: `Mengganti ke mode baca maraton.
Tiketmu akan secara otomatis terpakai jika diperlukan.`,
  viewer_marathon_viewing_last_ep_toast: `Tidak ada episode selanjutnya.`,
  viewer_marathon_viewing_first_ep_toast: `Tidak ada episode sebelumnya.`,
  viewer_marathon_viewing_guide_app: `Aktifkan mode baca maraton. Nikmati baca episode sampai habis hingga episode berikutnya dengan lancar.`,
  viewer_end_gidamu_plus_info: `Baca gratis setiap {{value}} jam untuk judul '{{contentname}}'`,
  viewer_end_like_first: `Jadilah orang pertama yang menyukai ini.`,
  viewer_end_like_snackbar: `Kamu suka cerita yang seperti ini, ya!
Kamu bisa memberikan hingga 5 likes untuk setiap episodenya.`,
  viewer_end_comment_count: `Lihat {{value}} komentar`,
  viewer_end_comment_count_zero: `Komentar 0`,
  viewer_end_comment_count_v4: `{{value}} komentar`,
  viewer_end_comment_button: `Melihat komentar`,
  viewer_end_next_button: `Baca selanjutnya <white>{{value}}</white>`,
  viewer_end_next_button_v4: `Baca selanjutnya {{value}}`,
  viewer_end_last_episode: `Tidak ada episode selanjutnya`,
  viewer_end_next_pull: `Scroll ke bawah untuk melihat <grey>{{value}}</grey>.`,
  viewer_end_recommendation_v4: `Karya serupa`,
  viewer_ep_list_free: `Gratis`,
  viewer_ep_list_gidamu: `Tunggu Gratis`,
  viewer_ep_list_rent: `Sewa`,
  viewer_ep_list_possess: `Permanen`,
  viewer_top_button: `Kembali ke atas`,
  viewer_page_swipe_snackbar: `Geser ke kiri`,
  viewer_page_swipe_right_snackbar: `Geser ke kanan`,
  viewer_setting_zoom_button: `Perbesar/Perkecil`,
  viewer_setting_preview_comment_button: `Preview komentar`,
  viewer_setting_remember_button: `Terakhir dilihat`,
  viewer_setting_autoscroll_button: `Autoscroll`,
  viewer_setting_autoscroll_button_v4: `Kecepatan Autoscroll`,
  viewer_setting_autoscroll_toast: `Beralih ke mode scroll otomatis.\n Kecepatan scroll dapat diubah dalam pengaturan.`,
  viewer_setting_bgm_button: `BGM`,
  viewer_setting_brightness: `Kecerahan layar`,
  viewer_setting_share_ep_button: `Bagikan episode`,
  viewer_setting_capture_screen_button: `Capture screen`,
  viewer_setting_view_page_button: `Page view`,
  viewer_setting_view_scroll_button: `Scroll view`,
  viewer_setting_capture_button: `Capture image`,
  viewer_setting_capture_saved: `Screenshot tersimpan di gallery`,
  viewer_setting_capture_access_required_popup: `Izin diperlukan untuk menyimpan screenshot`,
  viewer_setting_capture_access_authorization_required: `Izin akses foto dari KAKAO WEBTOON diperlukan untuk menyimpan screenshot.`,
  viewer_setting_hide_comment_off: `Nonaktifkan sembunyikan komentar`,
  viewer_setting_hide_comment_on: `Aktifkan sembunyikan komentar`,
  viewer_setting_enlarge_off: `Nonaktifkan enlarge`,
  viewer_setting_enlarge_on: `Aktifkan enlarge`,
  viewer_setting_last_viewed_off: `Nonaktifkan pengingat yang terakhir dibaca`,
  viewer_setting_last_viewed_on: `Aktifkan pengingat yang terakhir dibaca`,
  viewer_setting_sound_off: `Nonaktifkan suara`,
  viewer_setting_sound_on: `Aktifkan suara `,
  viewer_setting_view_page: `Page view`,
  viewer_setting_view_scroll: `Scroll view`,
  viewer_setting_view_page_switch_toast: `Ubah ke page view`,
  viewer_setting_view_scroll_switch_toast: `Ubah ke scroll view`,
  viewer_setting_enlarge_on_text: `Ketuk layar dua kali untuk memperbesar/memperkecil diaktifkan`,
  viewer_setting_enlarge_off_text: `Ketuk layar dua kali untuk menonaktifkan fitur Perbesar/Perkecil gambar.`,
  viewer_setting_preview_comment_on_text: `Preview BEST comment diaktifkan`,
  viewer_setting_preview_comment_off_text: `Preview BEST comment dinonaktifkan`,
  viewer_setting_last_viewed_on_text: `Pengingat terakhir dilihat diaktifkan`,
  viewer_setting_last_viewed_off_text: `Pengingat terakhir dilihat dinonaktifkan`,
  viewer_setting_autoscroll_on_text: `Tekan dan tahan layar untuk mengaktifkan Autoscroll`,
  viewer_setting_autoscroll_off_text: `Autoscroll dinonaktifkan`,
  viewer_setting_sound_on_text: `BGM diaktifkan`,
  viewer_setting_sound_off_text: `BGM dinonaktifkan`,
  viewer_onetouch_popup_title: `Kamu membutuhkan Tiket`,
  viewer_onetouch_popup_title_1_web: `Kamu membutuhkan {{value}}`,
  viewer_onetouch_popup_title_2_web: `Tiket untuk membaca episode selanjutnya.`,
  viewer_onetouch_popup_title_ticket: `Apa kamu mau menyewa episode untuk langsung membacanya?`,
  viewer_onetouch_popup_title_cash: `Apakah kamu ingin menyewa setelah membeli Cash? `,
  viewer_onetouch_popup_subtitle_gidamu: `Tiket tunggu gratis tidak bisa digunakan untuk membaca episode ini. `,
  viewer_onetouch_popup_content_balance: `Sisa Cash`,
  viewer_onetouch_popup_content_ticket: `Sewa Tiket (8 Days)`,
  viewer_onetouch_popup_button_ticket: `Sewa`,
  viewer_onetouch_popup_button_cash: `Beli Cash lalu beli Tiket Sewa`,
  viewer_onetouch_popup_button_options: `Beli Cash sekaligus lalu beli Tiket Permanen`,
  comment_title: `<bold>Komentar</bold> {{count}}`,
  comment_title_plural: `<bold>Komentar</bold> {{count}}`,
  comment_empty_first: `Jadilah orang pertama yang meninggalkan komentar.`,
  comment_account_deleted: `Hapus akun`,
  comment_unknown_user: `Tidak diketahui`,
  comment_see_comment_spoiler: `Komentar ini mengandung spoiler`,
  comment_button_dislike: `Tidak suka`,
  comment_button_dislike_plural: `Tidak suka`,
  comment_reply_title: `<bold>Balas</bold> {{count}}`,
  comment_reply_title_plural: `<bold>Balasan</bold> {{count}}`,
  comment_write_reply_title: `Tulis balasan`,
  comment_reply: `Balas`,
  comment_reply_plural: `Balasan`,
  comment_button_delete: `Hapus`,
  comment_button_delete_popup: `Apakah kamu yakin ingin menghapus komentar ini?`,
  comment_deleted_toast: `Komentar ini telah dihapus.`,
  comment_deleted_click_action_toast: `Komentar ini telah dihapus
permintaan tidak dapat di proses.`,
  comment_button_report: `Laporkan`,
  comment_report_already_report: `Kamu telah mengirimkan laporan`,
  comment_before_enter: `Tulis komentar`,
  comment_reply_before_enter: `Tulis balasan`,
  comment_reply_more: `Lihat lebih banyak balasan`,
  comment_button_enter: `Posting`,
  comment_button_block: `Blokir`,
  comment_block_popup_title: `Apakah kamu yakin akan memblokir {{nickname}}?`,
  comment_block_popup_content: `Kamu tidak dapat melihat komentar user.`,
  comment_block_toast: `User terblokir`,
  comment_already_blocked_toast: `User ini telah diblokir.`,
  comment_already_unblocked_toast: `User ini telah dibuka blokirnya.`,
  comment_block_displayed: `Komentar ini dari user terblokir.`,
  comment_button_unblock: `Buka blokir`,
  comment_unblock_popup_title: `Apakah kamu yakin akan membuka blokir {{nickname}}?`,
  comment_unblock_popup_content: `Kamu dapat melihat komentar user.`,
  comment_unblock_toast: `Pemblokiran pengguna dibatalkan`,
  comment_write_title: `Tulis komentar`,
  comment_write_spoiler_button: `Spoiler`,
  comment_write_snackbar: `Mohon tunggu beberapa saat untuk memposting komentar tambahan.`,
  login_comment_write_popup: `Kamu harus Masuk untuk menulis komentar`,
  login_comment_exceed_toast: `Jumlah karakter melebihi jumlah karakter yang dapat ditulis.`,
  comment_report_spam: `Spam`,
  comment_report_violence: `Kekerasan/Perilaku Berbahaya`,
  comment_report_illegal: `Ilegal`,
  comment_report_privacy: `Pengungkapan Informasi Pribadi`,
  comment_report_sexual: `Seksual Eksplisit`,
  comment_report_repeatedly: `Memposting komentar yang sama berulang kali`,
  comment_report_other: `Yang lainnya`,
  comment_report_other_inputbox: `Masukkan alasanmu (maksimal 500 karakter)`,
  comment_report_submitted_toast_short: `Laporan sudah terkirim.`,
  comment_report_submitted_toast: `Laporan sudah terkirim.
Komentar yang dilaporkan akan ditangani sesuai dengan kebijakan operasional.`,
  comment_report_read_more_button: `Baca selengkapnya`,
  comment_report_info: `Harap melaporkan komentar yang teridentifikasi ilegal atau tidak memenuhi tujuan penggunaan layanan. Komentar yang dilaporkan akan ditangani sesuai dengan kebijakan operasional, dan dapat mengakibatkan penalti tertentu jika melaporkan laporan palsu.`,
  comment_report: `Lapor`,
  comment_report_button: `Kirim laporan`,
  login_comment_report_popup: `Kamu harus Masuk untuk melaporkan komentar.`,
  comment_regulated: `Komentar Resmi`,
  comment_regulated_content: `Komentar ini disembunyikan untuk sementara.`,
  comment_regulated_popup_title: `Berdasarkan kebijakan operasional, akunmu terblokir sementara untuk memposting komentar.`,
  comment_regulated_popup_date_range: `Periode blokir: {{start}}~{{end}}`,
  comment_regulated_popup_date_permanent: `Periode blokir: Blokir permanen`,
  comment_regulated_popup_detail_1: `Kamu bisa menggunakan semua fasilitas selain penulisan komentar selama masa pemblokiran.`,
  comment_regulated_popup_detail_2: `Pemblokiran ini akan otomatis berakhir setelah masa periode blokir selesai.`,
  comment_regulated_popup_detail_3: `Pengulangan pelanggaran dapat dikenakan penalti yang lebih berat.`,
  comment_regulated_popup_detail_4: `Mohon hubungi Customer Service kami untuk pertanyaan lebih lanjut.`,
  more_title_ticket_history: `Riwayat Tiket`,
  ticket_history_add_tab: `Pembelian Tiket`,
  cash_history_used_detail: `Jumlah refund dapat berbeda dengan riwayat transaksi berdasarkan Event Cash yang telah kedaluwarsa.`,
  cash_history_used_rental: `{{count}} Tiket Sewa telah dibeli`,
  cash_history_used_rental_plural: `{{count}} Tiket Sewa telah dibeli`,
  cash_history_used_possession: `{{count}} Tiket Permanen telah dibeli`,
  cash_history_used_possession_plural: `{{count}} Tiket Permanen telah dibeli`,
  ticket_history_add_gift: `{{count}} Tiket Hadiah`,
  ticket_history_add_gift_plural: `{{count}} Tiket Hadiah`,
  ticket_history_add_gidamu: `1 Tiket Tunggu Gratis`,
  cash_history_valid_date: `Berlaku sampai {{date}}`,
  cash_history_used_rental_refunded: `Pembelian {{count}} Tiket Sewa telah dibatalkan`,
  cash_history_used_rental_refunded_plural: `Pembelian {{count}} Tiket Sewa telah dibatalkan`,
  cash_history_used_possession_refunded: `Pembelian {{count}} Tiket Permanen telah dibatalkan`,
  cash_history_used_possession_refunded_plural: `Pembelian {{count}} Tiket Permanen telah dibatalkan`,
  ticket_history_add_empty: `Tidak ada riwayat Tiket yang ditambahkan.`,
  ticket_history_used_tab: `Telah digunakan`,
  ticket_history_episode_range: `Ep.{{start}} - Ep.{{end}}`,
  ticket_history_used_empty: `Tidak ada riwayat penggunaan Tiket`,
  ticket_purchase_title: `Beli Tiket`,
  ticket_purchase_title_detail: `Hanya dapat digunakan pada karya ini.`,
  ticket_purchase_balance_rental: `Sisa Tiket Sewa`,
  ticket_purchase_balance_possession: `Sisa Tiket Permanen`,
  ticket_purchase_ep_unread: `Episode yang belum dibaca
(selain episode gratis)`,
  ticket_purchase_balance_cash: `Saldo Cash`,
  ticket_purchase_ineligible: `Tidak dapat membeli tiket pada karya ini`,
  ticket_purchase_rental: `Beli <purple>Tiket Sewa</purple>`,
  ticket_purchase_possession: `Beli <blue>Tiket Permanen</blue>`,
  ticket_purchase_all: `Beli sekaligus`,
  ticket_purchase_bonus_1: `{{count}} Tiket`,
  ticket_purchase_bonus_1_plural: `{{count}} Tiket`,
  ticket_purchase_bonus_2: ` + {{count}} Tiket Bonus`,
  ticket_purchase_bonus_2_plural: ` + {{count}} Tiket Bonus`,
  ticket_purchase_bonus_rental_2: `{{count}} <purple>+ {{bonus}} Tiket Bonus</purple>`,
  ticket_purchase_bonus_rental_2_plural: `{{count}} <purple>+ {{bonus}} Tiket Bonus</purple>`,
  ticket_purchase_bonus_possession_2: `{{count}} <blue>+ {{bonus}} Tiket Bonus</blue>`,
  ticket_purchase_bonus_possession_2_plural: `{{count}} <blue>+ {{bonus}} Tiket Bonus</blue>`,
  ticket_purchase_rental_regulation_1: `Episode yang dibeli dengan Tiket Sewa dapat dibaca selama 8 hari.`,
  ticket_purchase_rental_regulation_2: `Episode yang dibeli dengan Tiket Sewa dapat dibaca selama 8 hari, bukan dihitung dari masa pembelian Tiket.`,
  ticket_purchase_cashfriend: `Cash yang tersedia saat ini`,
  ticket_purchase_rental_discount: `Diskon Tiket Sewa`,
  ticket_purchase_possession_discount: `Diskon Tiket Permanen`,
  ticket_purchase_total_count: `Total`,
  ticket_purchase_total_price: `Subtotal`,
  ticket_purchase_total_regulation_1: `Tiket hanya dapat digunakan untuk judul ini.`,
  ticket_purchase_total_regulation_2: `Tiket Bonus tidak dapat di-refund.`,
  ticket_purchase_cancel: `Batal Beli`,
  ticket_purchase_total_limit_toast: `Pembelian maksimum dalam sekali
transaksi adalah 500.000 Cash `,
  ticket_purchase_shortage: `Cash tidak mencukupi`,
  ticket_purchase_shortage_amount: `Cash yang dibutuhkan`,
  more_title_cash_add: `Isi Cash`,
  ticket_purchase_shortage_add_notice: `Jika kamu membeli lebih dari {{value}} Cash, notifikasi konfirmasi pembelian mungkin akan muncul beberapa kali tergantung pada kebijakan pembelian melalui in-app.`,
  ticket_purchase_successful_rental: `Pembelian {{value}} Tiket Sewa berhasil `,
  ticket_purchase_successful_possession: `Pembelian {{value}} Tiket Permanen berhasil `,
  ticket_purchase_successful_balance_cash: `Saldo Cash: {{value}} Cash`,
  ticket_purchase_regulation: `Regulasi`,
  ticket_purchase_regulation_1: `Konten ini tidak dapat di-refund/ melakukan pembatalan pembelian tanpa pengecualian apa pun.`,
  ticket_purchase_regulation_2: `Proses refund tidak dapat dilakukan meskipun update episode mungkin saja tertunda.`,
  ticket_purchase_regulation_3: `Proses refund tidak dapat dilakukan atas berubahnya harga jual yang dapat terjadi sewaktu-waktu tergantung dari permintaan penerbit.`,
  ticket_purchase_regulation_4: `Tiket Bonus dalam pembelian Paket Tiket tidak dapat di-refund.`,
  ticket_purchase_regulation_5: `Sisa Tiket Sewa termasuk Tiket Hadiah.`,
  ticket_purchase_regulation_6: `Sisa Cash termasuk Event Cash`,
  ticket_purchase_regulation_7: `Saat melakukan pembelian sekaligus, kamu akan mendapatkan Tiket Hadiah berupa Tiket Sewa.`,
  ticket_purchase_regulation_8: `Pembelian sekaligus menampilkan opsi pembelian Tiket yang disesuaikan dengan jumlah episode yang belum dibaca.`,
  ticket_purchase_regulation_9: `Saat melakukan pembelian sekaligus, Tiket Bonus akan diterima secara bersamaan.`,
  ticket_purchase_regulation_10: `Bila melakukan refund dari Tiket ke Cash, Tiket yang belum terpakai akan ditarik oleh sistem`,
  more_title_cash_history: `Riwayat Cash`,
  cash_history_add_tab: `Pengisian`,
  cash_history_pass: `CASH PASS VIP`,
  cash_history_pass_banner: `Menerima benefit cashback {{value}}%`,
  cash_history_pass_benefit: `Menerima benefit cashback {{value}}%`,
  cash_history_pass_detail_button: `Lihat rincian`,
  cash_history_add_purchased: `Pengisian <gold>{{value}} Cash </gold> berhasil`,
  cash_history_expiration_date: `{{value}} Cash kedaluwarsa pada {{date}}`,
  cash_history_expiration_date_2lines: `{{value}} Cash 
kedaluwarsa pada {{date}}`,
  cash_history_event: `Event ・ {{campaign}}`,
  cash_history_currency: `Rp{{value}}`,
  cash_history_administrator: `Penarikan dari sistem`,
  cash_history_administrator_added: `Pemberian oleh sistem`,
  cash_history_store_refunded: `Pengembalian dana dari store`,
  cash_history_add_coupon: `Daftar Kupon`,
  cash_history_add_coupon_detail: `Daftar Kupon ・ {{campaign}}`,
  cash_history_add_auto_bonus: `Isi otomatis ・ bonus {{value}} Cash`,
  cash_history_add_purchased_bonus: `Isi Cash ・ bonus {{value}} Cash`,
  cash_history_minus_refunded: `Pengisian {{value}} Cash dibatalkan`,
  cash_history_minus_purchased: `Pengisian {{value}} Cash berhasil`,
  cash_history_added_empty: `Tidak ada Cash yang ditambahkan.`,
  cash_history_used_tab: `Penggunaan`,
  cash_history_used_empty: `Tidak ada riwayat penggunaan Cash.`,
  more_title_cash_add_auto: `Isi Cash otomatis`,
  cash_add_pass_benefit: `<bold>CASH PASS VIP</bold> maksimal cashback {{value}}%`,
  cash_add_auto_unapplied: `Menerima benefit cashback {{value}}%`,
  cash_add_balance: `Saldo Cash`,
  cash_add_pass: `CASH PASS VIP`,
  cash_add_pass_inuse: `Digunakan`,
  cash_add_title: `Isi <gold>Cash</gold>`,
  cash_add_first_purchase_event: `Diskon pembelian pertama`,
  cash_add_discount_title: `Diskon Cash`,
  cash_add_authentication_popup: `Pengisian Cash telah mencapai limit. Verifikasikan akunmu untuk melanjutkan pengisian.
(Akun yang belum terverifikasi hanya dapat mengisi sampai Rpxxx)`,
  cash_add_authentication_button: `Verifikasi`,
  cash_add_payment_limit_popup_title: `Telah mencapai limit`,
  cash_add_payment_limit_popup_content: `Pengisian Cash telah mencapai limit, dan akan diperbarui setiap tanggal 1 pukul 00:00 WIB.`,
  cash_add_payment_limit_exceed_popup: `Cash yang kamu miliki telah mencapai limit`,
  cash_add_payment_limit_exceed_popup_content: `Maksimal Cash yang bisa kamu miliki {{value1}}. Cash yang bisa kamu isi {{value2}}`,
  cash_add_payback: `{{value}} Cash <gold>+ {{bonus}} Cash</gold>`,
  cash_add_item_badge_recommend: `Best deal`,
  cash_add_item_badge_popular: `Populer`,
  cash_add_agree_button: `Saya setuju dengan syarat dan ketentuan.`,
  cash_add_next_button: `Berikutnya`,
  cash_add_guides: `Panduan Pengisian Cash`,
  cash_add_amount_popup_title: `Pilih nominal`,
  cash_add_payment_popup_title: `Pilih metode pembayaran`,
  cash_add_payment_popup_button: `Bayar`,
  cash_add_payment_processed_toast: `Mohon tunggu.
Pembayaranmu sedang diproses.`,
  cash_add_payment_processed_popup: `Pembayaran sedang dalam proses. 
Diperlukan waktu sekitar 20 detik 
dan pesan ini akan otomatis tertutup 
setelah pembayaran selesai.`,
  cash_add_success_popup: `{{value}} Cash berhasil diisi.`,
  cash_add_balance_popup: `Saldo Cash: {{value}} Cash`,
  cash_add_fail_popup: `Gagal mengisi {{value}} Cash.
Silakan coba lagi.`,
  cash_add_fail_popup_content: `Informasi transaksi tidak valid`,
  cash_add_pending_toast: `Pembayaran telah gagal.
Silakan periksa metode pembayaran pada google store.
Bila tidak ada kendala, silakan coba kembali pembayaran.`,
  cash_add_payment_processing_popup: `Pembayaran sedang berlangsung. 
Silakan periksa lagi nanti.`,
  error_unsupported_browser: `Versi browser tidak mendukung.
Silakan update browser-mu ke versi terbaru.`,
  error_unsupported_os: `Versi OS tidak mendukung.
Silakan update OS-mu ke versi terbaru.`,
  billing_msg_invalid_msg: `Permintaan tidak valid`,
  billing_msg_invalid_parameter: `Informasi yang diminta tidak valid.`,
  billing_msg_service_fail: `Terjadi masalah yang tidak dapat diketahui.`,
  billing_msg_invalid_required_parameter: `Parameter yang diperlukan tidak tersedia. `,
  billing_msg_fail_get_user_info: `Gagal mencari informasi user.`,
  billing_msg_invalid_user_info: `Informasi user tidak valid.`,
  billing_msg_invalid_user_region: `Negara layanan tidak valid`,
  billing_msg_invalid_billing_hash: `Verifikasi permintaan data gagal.`,
  billing_msg_intro_fail_get_account_balance: `Gagal menampilkan saldo Cash`,
  billing_msg_intro_fail_get_view_intro: `Gagal menemukan informasi produk.`,
  billing_msg_intro_payment_policy_not_exist: `Tidak ada informasi tentang syarat dan ketentuan pembayaran`,
  billing_msg_intro_payment_item_not_exist: `Tidak ada informasi tentang pembayaran item.`,
  billing_msg_request_invalid_price: `Informasi jumlah pembayaran tidak valid.`,
  billing_msg_request_invalid_item_id: `Informasi produk permintaan pembayaran tidak valid.`,
  billing_msg_request_fail_get_item_info: `Gagal menemukan informasi produk.`,
  billing_msg_request_item_not_exists: `Tidak ada informasi produk`,
  billing_msg_request_fail_get_payment_id: `Gagal mendaftarkan informasi pembayaran.`,
  billing_msg_request_fail_get_pg_url: `Gagal menampilkan informasi pembayaran.`,
  billing_msg_result_invalid_pay_info: `Informasi pembayaran tidak valid.`,
  billing_msg_result_pg_fail: `Gagal melakukan pembayaran. Silakan coba kembali`,
  billing_msg_credit_info_not_exists: `Tidak ada informasi pembayaran.`,
  billing_alert_check_agree: `Harap setujui syarat dan ketentuan pembayaran.`,
  billing_alert_invalid_price: `Informasi jumlah tidak valid.`,
  billing_alert_invalid_item_info: `Informasi produk tidak valid.`,
  billing_common_404: `Halaman yang diminta tidak ditemukan.`,
  billing_msg_already_other_device_login: `Kamu telah telah Keluar dari perangkat ini, karena Masuk dengan perangkat lain.`,
  billing_msg_invalid_access_logout: `Keluar karena akses tidak valid.`,
  billing_msg_already_login: `Kamu perlu Masuk`,
  billing_msg_web_unavailable: `Cash hanya bisa ditambahkan melalui aplikasi. Apakah kamu mau membuka aplikasi?`,
  billing_msg_pc_unavailable: `Cash hanya bisa ditambahkan melalui aplikasi.
Silakan unduh aplikasi.
`,
  billing_msg_first_puchase_only: `Anda telah melampaui jumlah pembayaran yang dapat dilakukan.`,
  library_tab_recent: `Terbaru`,
  library_tab_recent_phrase_default: `Berikut karya
KAKAO WEBTOON
Terpopuler`,
  library_tab_recent_phrase_login_genre: `Karena 
{{userid}} membaca 
{{genre_1}}`,
  library_tab_recent_phrase_popular: `Gimana kalau 
kali ini baca 
{{genre_1}}?`,
  library_tab_recent_phrase_login_title: `Karena 
{{userid}} membaca 
{{title}}`,
  library_tab_recent_phrase_nonlogin_style: `Gimana kalau 
yang gambarnya 
serupa dengan {{title}}?`,
  library_tab_recent_phrase_nonlogin_genre: `Karena kamu 
menyukai {{genre_1}} 
belakangan ini`,
  library_tab_recent_phrase_nonlogin_title: `Karena kamu menyukai 
{{title}} 
belakangan ini`,
  library_tab_recent_phrase_title: `Karena kamu baca
{{title}}
belakangan ini`,
  library_tab_recent_phrase_rec: `KAKAO WEBTOON
punya rekomendasi, nih!
Mau coba baca?`,
  library_tab_recent_empty: `Di sini kamu bisa melihat judul yang baru saja dilihat.`,
  library_see_all_button: `Lihat semua`,
  library_tab_recent_sort_recent: `Terakhir di lihat`,
  library_tab_recent_sort_update: `Tanggal update`,
  library_tab_recent_sort_recent_toast: `Berdasarkan terakhir di lihat`,
  library_tab_recent_sort_update_toast: `Berdasarkan tanggal update.`,
  library_tab_recent_sort_download_toast: `Berdasarkan tanggal unduhan`,
  library_tab_recent_sort_storage_toast: `Berdasarkan kapasitas`,
  library_edit_button: `Edit`,
  library_select_all_button: `Pilih semua`,
  library_delete_episode_button: `Hapus {{count}} episode`,
  library_delete_episode_button_plural: `Hapus {{count}} episode`,
  library_delete_content_button: `Hapus {{count}} karya`,
  library_delete_content_button_plural: `Hapus {{count}} karya`,
  library_tab_recent_delete_popup: `Apakah kamu yakin ingin menghapus {{count}} karya yang telah kamu baca?`,
  library_tab_recent_delete_popup_plural: `Apakah kamu yakin ingin menghapus {{count}} karya yang telah kamu baca?`,
  library_tab_recent_delete_popup_v4: `Apakah kamu yakin ingin menghapus {{value}} karya yang telah kamu baca dari daftar?`,
  library_tab_recent_delete_popup_plural_v4: `Apakah kamu yakin ingin menghapus {{value}} karya yang telah kamu baca dari daftar?`,
  library_tab_recent_language_toast: `Kamu harus mengganti pengaturan ke bahasa {{language}} untuk membaca karya ini.`,
  library_tab_recent_language_toast_v4: `Karya ini tidak bisa dibaca dalam pengaturan bahasa saat ini. `,
  library_tab_favorites: `Favoritku`,
  library_tab_favorites_on: `ON`,
  library_tab_favorites_off: `OFF`,
  library_tab_favorites_device_popup: `Pengaturan notifikasimu dinonaktifkan. Apakah kamu ingin mengatur ulang pengaturannya?`,
  library_tab_favorites_episode_popup: `Apakah kamu ingin mengaktifkan notifikasi dan mendapatkan update?`,
  library_tab_favorites_episode_popup_button: `Aktifkan Notifikasi`,
  library_tab_favorites_episode_toast: `Terima notifikasi episode update`,
  library_before_login: `Tersedia setelah Masuk`,
  library_tab_favorites_before_login: `Masuk untuk menambahkan karya ke Favorit dan terima notifikasi episode update.`,
  library_tab_empty: `Favoritkan karya yang kamu suka untuk menerima notifikasi episode update.`,
  library_tab_favorites_available_fav: `{{count}}
karya ada di 
Favoritmu`,
  library_tab_favorites_available_fav_plural: `{{count}} 
karya ada di
Favoritmu`,
  library_tab_favorites_available_update: `{{count}} 
episode baru 
telah di-update`,
  library_tab_favorites_available_update_plural: `{{count}} 
episode baru 
telah di-update`,
  library_tab_favorites_unavailable: `Tidak ada episode
yang di favoritkan`,
  library_tab_favorites_sort_update: `Tanggal update`,
  library_tab_favorites_sort_added: `Favorit`,
  library_tab_favorites_sort_update_toast: `Tanggal update`,
  library_tab_favorites_sort_added_toast: `Penambahan`,
  library_tab_favorites_delete_title: `Edit`,
  library_tab_favorites_delete_popup: `Apakah kamu yakin ingin menghapus 
{{count}} karya dari Favoritmu?`,
  library_tab_favorites_delete_popup_plural: `Apakah kamu yakin ingin menghapus 
{{count}} karya dari Favoritmu?`,
  library_tab_downloads: `Unduhan`,
  library_tab_download_available_episode: `{{count}} 
episode 
telah diunduh`,
  library_tab_download_available_episode_plural: `{{count}} 
episode 
telah diunduh`,
  library_tab_download_unavailable_series: `Belum ada karya 
yang diunduh`,
  library_tab_download_before_login: `Masuk untuk mengunduh karya dan nikmati dalam mode offline.`,
  library_tab_download_empty: `Download karya untuk menikmatinya dalam mode offline.`,
  library_tab_download_sort_download: `Unduhan`,
  library_tab_download_sort_storage: `Jumlah`,
  library_tab_download_refresh: `Refresh`,
  library_delete_title_button: `Hapus {{value}} karya `,
  library_tab_download_free: `Gratis`,
  library_tab_download_rent: `Sewa`,
  library_tab_download_possess: `Permanen`,
  library_tab_download_expired: `Masa sewa telah berakhir`,
  library_tab_download_paid: `Ganti ke episode berbayar`,
  library_tab_download_expired_toast: `Masa sewa telah berakhir. Silakan unduh kembali untuk membaca karyanya.`,
  library_tab_downloads_delete_popup: `Apakah kamu yakin ingin menghapus {{count}} karya yang telah diunduh?`,
  library_tab_downloads_delete_popup_plural: `Apakah kamu yakin ingin menghapus {{count}} karya yang telah diunduh?`,
  library_tab_downloads_delete_popup_v4: `Apakah kamu yakin ingin menghapus {{value}} karya yang telah diunduh?`,
  library_tab_downloads_delete_popup_plural_v4: `Apakah kamu yakin ingin menghapus {{value}} karya yang telah diunduh?`,
  library_tab_downloads_delete_ep_popup: `Apakah kamu yakin ingin menghapus {{count}} episode yang telah diunduh?`,
  library_tab_downloads_delete_ep_popup_plural: `Apakah kamu yakin ingin menghapus {{count}} episode yang telah diunduh?`,
  library_tab_downloads_delete_ep_popup_v4: `Apakah kamu yakin ingin menghapus {{value}} episode yang telah diunduh?`,
  library_tab_downloads_delete_ep_popup_plural_v4: `Apakah kamu yakin ingin menghapus {{value}} episode yang telah diunduh?`,
  library_tab_download_offline_toast: `Tidak bisa mengubah ke mode offline`,
  library_tab_download_network_popup: `Silakan periksa koneksi jaringanmu dan coba kembali`,
  offline_download_empty_title: `Tidak ada karya yang telah diunduh.`,
  offline_download_empty_episode: `Tidak ada episode yang telah diunduh.`,
  offline_download_network_toast: `Koneksi jaringan dibutuhkan untuk menggunakan layanan unduhan.`,
  error_network_popup_title: `Silakan periksa koneksi jaringanmu`,
  error_network_popup_content: `Silakan coba kembali setelah memeriksa koneksi Wi-Fi atau data seluler dan status mode pesawat di perangkatmu.`,
  library_tab_possessed: `Telah dibeli`,
  library_tab_possessed_available: `{{count}} 
episode 
telah dibeli`,
  library_tab_possessed_available_plural: `{{count}} 
episode 
telah dibeli`,
  library_tab_possessed_unavailable_series: `Tidak ada konten yang telah dibeli`,
  library_tab_possessed_unavailable_episode: `Tidak ada episode yang dibeli.`,
  library_tab_possessed_sort_update: `Update`,
  library_tab_possessed_sort_possessed: `Tanggal pembelian `,
  library_tab_possessed_sort_update_toast: `Tanggal update`,
  library_tab_possessed_sort_possessed_toast: `Tanggal pembelian`,
  library_tab_possessed_sort_episode_count: `{{count}} episode telah dibeli.`,
  library_tab_possessed_sort_episode_count_plural: `{{count}} episode telah dibeli.`,
  library_tab_possessed_sort_episode_free: `Episode gratis`,
  library_tab_possessed_sort_episode_expired: `Periode masa sewa`,
  library_tab_possessed_empty: `Tidak ada episode yang dibeli dengan Tiket Berbayar`,
  library_tab_possessed_empty_ticket: `Tersisa {{count}} Tiket`,
  library_tab_possessed_empty_ticket_plural: `Tersisa {{count}} Tiket`,
  library_tab_possessed_empty_ticket_button: `Pergi ke halaman karya`,
  library_tab_possessed_delete_popup_v4: `Karya yang dipilih telah disembunyikan dari daftar karya yang dibeli. Jika kamu ingin melihatnya, aktifkan "ubah" pada mode edit.`,
  library_tab_possessed_deleted_toast: `Daftar pembelian dibersihkan`,
  library_tab_possessed_episode_button: `{{count}} episode`,
  library_tab_possessed_episode_button_plural: `{{count}} episode`,
  library_hide_title_button: `Sembunyikan {{count}} karya`,
  library_hide_title_button_plural: `Sembunyikan {{count}} karya `,
  library_tab_possessed_delete_popup: `Apakah kamu yakin ingin menghapus {{count}} karya yang telah dibeli? Nantinya akan ditambahkan kembali ke Library jika kamu membelinya lagi.`,
  library_tab_possessed_delete_popup_plural: `Apakah kamu yakin ingin menghapus {{count}} karya yang telah dibeli? Nantinya akan ditambahkan kembali ke Library jika kamu membelinya lagi.`,
  library_tab_possessed_before_login: `Cek konten yang telah dibeli`,
  library_tab_comments: `Komentar`,
  library_tab_comments_unavailable: `Kamu tidak memiliki komentar yang ditulis.`,
  library_tab_comments_delete_popup: `Apakah kamu ingin menghapus {{count}} komentar yang telah kamu tulis?`,
  library_tab_comments_delete_popup_plural: `Apakah kamu ingin menghapus {{count}} komentar yang telah kamu tulis?`,
  giftbox_cashfriend: `Cash tersedia sekarang`,
  giftbox_onboarding: `Dapatkan Tiket Hadiah jika kamu Masuk sekarang!`,
  giftbox_tab_event: `Event`,
  giftbox_tab_event_participated: `Telah diikuti`,
  giftbox_tab_event_empty: `Tidak ada event yang bisa kamu ikuti.`,
  giftbox_tab_event_empty_global: `Belum ada event
yang bisa 
kamu ikuti`,
  giftbox_ticket_gift: `Tiket 
Hadiah`,
  giftbox_tab_ticket_receive_button: `Terima {{count}} Tiket`,
  giftbox_tab_ticket_receive_button_plural: `Terima {{count}} Tiket`,
  luckydraw_ticket_button: `Ke halaman karya`,
  giftbox_tab_ticket_received: `Telah diterima`,
  giftbox_tab_ticket_empty: `Tidak ada Tiket yang bisa kamu terima.`,
  giftbox_tab_ticket_empty_global: `Tidak ada 
Tiket yang 
diterima`,
  giftbox_tab_ticket_empty_korea: `Tidak ada 
hadiah yang 
diterima`,
  giftbox_tab_received_popup: `Menerima {{count}} Tiket Hadiah`,
  giftbox_tab_received_popup_plural: `Menerima {{count}} Tiket Hadiah`,
  giftbox_tab_received_valid_within_popup: `Kedaluwarsa: 3 hari setelah diterima`,
  search_title: `Cari`,
  search_main_question: `Apa yang
kamu cari?`,
  search_main_question_1_web: `Apa yang`,
  search_main_question_2_web: `kamu cari?`,
  search_input_before_enter: `Masukkan judul, pengarang, atau genre`,
  search_recent: `Pencarian terakhir`,
  search_recent_plural: `Pencarian terakhir`,
  search_result_empty: `"{{value}}"
Pencarian tidak ditemukan`,
  search_result_empty_web: `Pencarian tidak ditemukan`,
  notification_title: `Notifikasi`,
  notification_tab_my: `Beritaku`,
  notification_tab_gidamu: `Tunggu Gratis`,
  notification_tab_gidamu_complete: `Satu episode gratis untuk dibaca`,
  notification_before_login: `Tersedia setelah Masuk`,
  gidamu_notification_list_blank: `Tidak ada pemberitahuan tiket tunggu gratis.`,
  notification_list_blank: `Tidak ada notifikasi`,
  notification_tab_notice: `Pemberitahuan`,
  notification_notice_list_deleted: `Pemberitahuan ini telah dihapus.`,
  notification_valid_specific_date: `Berlaku sampai {{value}}`,
  notification_expiry_bydate: `Kedaluwarsa: {{count}} hari setelah diterima`,
  notification_expiry_bydate_plural: `Kedaluwarsa: {{count}} hari setelah diterima`,
  notification_expiry_byhour: `Masa kedaluwarsa: {{count}} jam dari waktu diterima`,
  notification_expiry_byhour_plural: `Masa kedaluwarsa: {{count}} jam dari waktu diterima`,
  notification_expiry_specific_date: `Berlaku sampai {{value}}`,
  notification_expiry_today: `Masa kedaluwarsa: Hari ini`,
  notification_expiry_hour: `Masa kedaluwarsa: 59 menit dari waktu penerimaan`,
  notification_tab_gidamu_delete_button: `Hapus {{count}} notifikasi`,
  notification_tab_gidamu_delete_button_plural: `Hapus {{count}} notifikasi`,
  notification_tab_gidamu_delete_popup_title: `Apakah kamu yakin akan berhenti menerima notifikasi 'Tunggu Gratis' pada judul {{count}}?`,
  notification_tab_gidamu_delete_popup_title_plural: `Apakah kamu yakin akan berhenti menerima notifikasi 'Tunggu Gratis' pada judul {{count}}?`,
  notification_tab_gidamu_delete_popup_content: `Menggunakan 'Tiket Tunggu Gratis' akan melanjutkan notifikasi pada judul.`,
  notification_push_waitandfree_title: `[Tunggu Gratis] {{value}}`,
  notification_push_waitandfree_content: `Nikmati baca satu episode gratis!`,
  notification_push_ticket_expire_title: `Tiket-mu akan segera kedaluwarsa`,
  notification_push_ticket_expire_content: `{{count}} Tiket untuk {{title}} kedaluwarsa hari ini.`,
  notification_push_ticket_expire_content_plural: `{{count}} Tiket untuk {{title}} kedaluwarsa hari ini.`,
  notification_push_cash_expire_title: `Event Cash-mu akan segera kedaluwarsa`,
  notification_push_cash_expire_content: `Beli Tiket dengan Cash sebelum kedaluwarsa`,
  notification_push_title_update_title: `{{value}} telah di-update`,
  notification_push_title_update_content_multiple: `'{{start}} ~ {{end}}' telah di-update`,
  notification_push_title_update_content_single: `'{{value}}' telah di-update.`,
  notification_push_comment_like_title: `{{value}} menyukai komentarmu.`,
  notification_push_comment_like_title_multiple: `{{count}} dan {{count}} lainnya menyukai komentarmu.`,
  notification_push_comment_like_title_multiple_plural: `{{count}} dan {{count}} lainnya menyukai komentarmu.`,
  notification_push_comment_reply_title: `membalas komentarmu.`,
  notification_push_comment_reply_content: `[{{content}} - {{episode}}]`,
  notification_push_comment_reply_event_content: `[{{value}}]`,
  notification_push_gift_ticket_content: `Kamu Menerima Tiket Hadiah`,
  notification_push_gift_cash_content: `Kamu mendapat {{value}} Cash`,
  notification_push_gift_coupon_title: `[Kupon telah terdaftar]`,
  notification_push_gift_slot_content: `Mainkan Lucky Draw sekarang`,
  notification_push_gift_luckydraw_title: `Lucky Draw telah tiba`,
  notification_push_gift_prize_title: `Selamat kamu mendapat {{prize}}`,
  notification_push_gift_prize_content: `Harap berikan informasi untuk mengklaim hadiah kamu sebelum kedaluwarsa.`,
  notification_push_popup_title_update_deleted: `Konten ini telah dihapus`,
  notification_push_popup_event_expired: `Event ini telah berakhir`,
  notification_push_popup_common_language: `Tidak bisa memproses permintaanmu karena perubahan bahasa. Mohon ganti pengaturan bahasa untuk memeriksa riwayat notifikasimu. `,
  notification_raffle_page_title: `Hadiah telah tiba`,
  notification_raffle_received: `Kamu telah mendapat hadiah`,
  notification_raffle_received_name: `Hadiah`,
  notification_raffle_received_date: `Diterima pada `,
  more_menu: `Side Menu`,
  more_login_eng: `Masuk`,
  more_title_cash_add_auto_applied: `Menerima benefit cashback {{value}}%`,
  more_title_cash_add_auto_unapplied: `Daftar sekarang dan dapatkan cashback hingga {{value}}%`,
  more_title_coupon_redeem: `Daftar Kupon`,
  more_title_notification: `Beritaku`,
  more_title_notice: `Pemberitahuan`,
  more_title_display_mode: `Mode Tampilan`,
  more_title_display_mode_dark: `Mode Gelap`,
  more_title_display_mode_light: `Mode Terang`,
  more_title_display_mode_system: `Pengaturan Sistem`,
  more_title_content_notification: `Notifikasi Karya`,
  more_title_content_notification_before_login: `Tersedia setelah Masuk `,
  more_title_content_notification_episode: `Notifikasi Episode Update`,
  more_title_content_notification_gidamu: `Notifikasi Tunggu Gratis`,
  more_title_system_preferences: `Preferensi`,
  more_title_system_preferences_autoplay: `Otomatis putar video`,
  more_title_system_preferences_data: `Baca episode hanya dalam jaringan Wifi`,
  more_title_app_setting: `Pengaturan Aplikasi`,
  settings_title_web: `Pengaturan `,
  more_login_message: `Silakan Masuk`,
  more_cash_add_auto_unapplied: `Dapatkan cashback hingga {{value}}%`,
  more_cashfriends: `Cash yang bisa kamu dapat sekarang`,
  more_myinfo: `Infoku`,
  more_myinfo_nickname: `Nickname`,
  more_myinfo_userid: `User ID`,
  more_myinfo_userid_copy_toast: `Tersalin`,
  more_myinfo_account: `Akunku`,
  more_myinfo_logout_popup: `Apakah kamu yakin ingin Keluar?`,
  more_myinfo_nickname_unknown: `Tidak diketahui`,
  more_myinfo_nickname_change: `Ubah nickname`,
  more_myinfo_nickname_enter: `Masukkan nickname-mu`,
  more_myinfo_nickname_limit_guide: `<white>{{value}}</white>/20`,
  more_myinfo_nickname_toast: `Tersimpan`,
  more_myinfo_nickname_banned_toast: `{{word}} tidak dapat digunakan sebagai nickname.`,
  more_myinfo_nickname_emoticon: `Nickname terdiri atas 2-20 karakter dan simbol yang dapat digunakan; (-), (_)`,
  more_myinfo_nickname_change_button: `Ubah`,
  more_myinfo_nickname_length: `Masukkan 2-20 karakter.`,
  more_myinfo_nickname_character: `Hanya dapat memasukkan karakter berupa huruf, angka dan simbol (-) (_)`,
  more_myinfo_account_delete: `Hapus akun`,
  more_myinfo_account_delete_precautions: `Peringatan dalam hapus akun`,
  more_myinfo_account_delete_precautions_detail_1: `Semua riwayat seperti riwayat pembelian dan riwayat Tiket akan dihapus secara permanen ketika akun dihapus dan tidak dapat dipulihkan.`,
  more_myinfo_account_delete_precautions_detail_2: `Komentarmu akan ditampilkan sebagai 'Komentar akun yang telah dihapus'. Jika tidak ingin ditampilkan, harap hapus komentarmu sebelum menghapus akun.`,
  more_myinfo_account_delete_precautions_detail_3: `Tiket yang tidak digunakan dan Cash yang tersisa akan kedaluwarsa saat akunmu dihapus.`,
  more_myinfo_account_delete_precautions_detail_4: `Cash yang ditambahkan via pembelian in-app tidak dapat di-refund oleh KAKAO WEBTOON. Mohon hubungi GooglePlay atau App store di mana kamu melakukan pembelian untuk mendapatkan refund.`,
  more_myinfo_account_delete_precautions_detail_5: `Kamu tidak dapat meregistrasi ulang dengan akun yang sama dalam 30 hari setelah menghapus akun.`,
  more_myinfo_account_delete_agreed: `Saya telah membaca dan menyetujui 
seluruh peringatan tersebut.`,
  more_myinfo_account_delete_button: `Hapus akun KAKAO WEBTOON`,
  more_myinfo_account_delete_confirm_popup: `Setelah akun dihapus Cash dan riwayat Tiket atau riwayat layanan lainnya akan segera dihapus, apakah kamu yakin ingin menghapusnya?`,
  more_myinfo_account_delete_toast: `Akun telah dihapus`,
  more_help: `Bantuan`,
  more_help_faq: `Pertanyaan yang sering diajukan`,
  more_customer: `Customer Service`,
  more_customer_rights_report: `Panduan pengaduan perlindungan hak cipta`,
  more_customer_title_inquiry: `Pertanyaan layanan`,
  more_customer_inquiry: `Hubungi kami`,
  more_customer_inquiry_global_title: `[Help] Pertanyaan untuk KAKAO WEBTOON`,
  more_customer_inquiry_global_question_1: `Apa kendalamu? (Ada error, saran, dll)`,
  more_customer_inquiry_global_question_2: `Apa kendalanya? (Pada saat terjadi error, kami dapat memberikan bantuan yang akurat jika kamu mengisi detail prosesnya dan seberapa sering error tersebut terjadi.)`,
  more_customer_inquiry_global_question_3: `Jika ada video maupun screenshot dari layar, mohon dilampirkan sebagai bukti penunjang yang akurat.`,
  more_customer_inquiry_info_id: `User ID`,
  more_customer_inquiry_info_version_app: `Versi Aplikasi`,
  more_customer_inquiry_info_browser: `Browser`,
  more_customer_inquiry_info_device: `Perangkat`,
  more_customer_inquiry_info_device_language: `Bahasa perangkat`,
  more_customer_inquiry_info_version_ios: `Versi iOS`,
  more_customer_inquiry_info_version_aos: `Versi Android`,
  more_customer_inquiry_global_agreement_notice: `Dengan mengirimkan pertanyaan melalui email di atas, kamu telah menyetujui Kebijakan Privasi dan Persyaratan Layanan kami.`,
  more_customer_support_email_address: `support_id@kakaowebtoon.com`,
  more_customer_support_email_address_th: `cs.th@kakaoent.com`,
  more_customer_support_email_address_tw: `support_tw@kakaowebtoon.com `,
  more_customer_inquiry_category: `Pilih Pertanyaan`,
  more_customer_inquiry_category_refund_ticket: `Pertanyaan Refund Tiket`,
  more_customer_inquiry_category_refund_cash: `Refund Cash`,
  more_customer_inquiry_category_report_rights: `Adukan pelanggaran hak cipta`,
  more_customer_inquiry_category_general: `Pertanyaan Umum`,
  more_customer_inquiry_category_suggestions: `Saran`,
  more_customer_inquiry_category_problems: `Kendala yang pernah dialami`,
  more_customer_inquiry_category_cashfriends_level: `Tanyakan mengenai Cash Friends (level)`,
  more_customer_inquiry_category_cashfriends_join: `Tanyakan mengenai Cash Friends (join)`,
  more_customer_inquiry_guide_ID: `KAKAO user ID:`,
  more_customer_inquiry_guide_ID_detail: `User ID dapat ditemukan di 'Infoku'`,
  more_customer_inquiry_guide_refund_series: `Judul karya yang ingin kamu refund:`,
  more_customer_inquiry_guide_refund_price: `Harga:`,
  more_customer_inquiry_guide_refund_platform: `(App/Web)`,
  more_customer_inquiry_guide_refund_reason: `Alasan refund:`,
  more_customer_inquiry_guide_inquiries: `Pertanyaan:`,
  more_customer_inquiry_guide_report: `Mohon masukkan informasi yang jelas dari konten yang ingin kamu adukan.`,
  more_customer_inquiry_guide_account: `Akun KAKAO:`,
  more_customer_inquiry_guide_report_episode: `Judul Karya/episode:`,
  more_customer_inquiry_guide_report_publisher: `Penerbit dari episode:`,
  more_customer_inquiry_guide_questions: `Pertanyaan:`,
  more_customer_inquiry_guide_suggestions: `Saran:`,
  more_customer_inquiry_guide_problems_date: `Tanggal kejadian:`,
  more_customer_inquiry_guide_problems_detail: `Detail:`,
  more_customer_inquiry_guide_participated_date: `Tanggal partisipasi:`,
  more_customer_inquiry_guide_participated_name: `Sebutkan event yang kamu ikuti:`,
  more_customer_inquiry_guide_purchase_date: `Tanggal beli:`,
  more_customer_inquiry_guide_purchase_product: `Produk yang dibeli:`,
  more_customer_inquiry_guide_purchase_number: `Nomor order:`,
  more_customer_inquiry_guide_name: `Nama:`,
  more_customer_inquiry_guide_birthdate: `Tanggal lahir:`,
  more_customer_inquiry_refund_ticket_input_detail: `*Tiket Hadiah tidak dapat di-refund, dan pembelian Tiket dengan menggunakan Event Cash dapat di-refund sebelum kedaluwarsa.`,
  more_customer_inquiry_answer_number: `Nomor HP yang dapat dihubungi`,
  more_customer_inquiry_answer_number_error: `Silakan masukkan nomor HP yang valid`,
  more_customer_inquiry_answer_email: `Alamat email yang dapat dihubungi`,
  more_customer_inquiry_answer_email_error: `Silakan masukkan alamat email yang valid`,
  more_customer_inquiry_country: `Pilih negara`,
  more_customer_inquiry_attachment: `Tambahkan lampiran`,
  more_customer_inquiry_attachment_button: `Tambahkan`,
  more_customer_inquiry_attachment_detail_2: `Hanya file dengan format jpg, png, docx, dan doc saja yang dapat dilampirkan`,
  more_customer_inquiry_guide_attachment_app: `Pertanyaan dan lampiran dapat dikirimkan ke 
support_id@kakaowebtoon.com`,
  more_customer_inquiry_guide_attachment_web: `Jika lampiran gagal terkirim, silakan kirim ke support_id@kakaowebtoon.com`,
  more_customer_inquiry_agreement_title: `Kebijakan privasi dan informasi`,
  more_customer_inquiry_agreement_1: `Kami dapat mengumpulkan email dan nomor HP untuk mengecek kendala dan melakukan follow up.`,
  more_customer_inquiry_agreement_2: `Tanggal lahir maupun informasi perangkat dapat dikumpulkan. Pengenal tambahan untuk iklan (ADID, IDFA) tergantung pada jenis pertanyaan.`,
  more_customer_inquiry_agreement_3: `Seluruh data pribadi user akan dihapus setelah 3 tahun. Setelah itu data akan dimusnahkan.`,
  more_customer_inquiry_agreement_check: `Saya setuju dengan pernyataan di atas`,
  more_customer_inquiry_send_button: `Kirim`,
  more_customer_inquiry_send_toast: `Pertanyaan terkirim`,
  more_customer_inquiry_history: `Pertanyaanku`,
  more_customer_inquiry_history_detail: `Pertanyaan yang dibuat hanya dapat dilihat maksimal satu tahun.`,
  more_customer_inquiry_history_empty: `Tidak ada pertanyaan`,
  more_serviceinfo: `Informasi layanan`,
  more_serviceinfo_terms: `Ketentuan dan kebijakan`,
  more_serviceinfo_terms_cookie: `Kebijakan Cookie`,
  more_serviceinfo_terms_use: `Ketentuan Penggunaan`,
  more_serviceinfo_terms_personal: `Kebijakan Privasi`,
  more_serviceinfo_terms_youth: `Kebijakan Perlindungan Anak di Bawah Umur`,
  more_serviceinfo_terms_operational: `Kebijakan Operasional`,
  more_serviceinfo_terms_payment: `Ketentuan Penggunaan Pembayaran`,
  more_serviceinfo_terms_payment_policy: `Kebijakan Pengoperasian Layanan Pembayaran`,
  more_serviceinfo_terms_customized: `Panduan penyediaan iklan dan konten`,
  more_serviceinfo_openlicense: `Lisensi terbuka`,
  more_serviceinfo_business: `Informasi bisnis`,
  more_serviceinfo_business_name_company: `Nama perusahaan`,
  more_serviceinfo_business_name_corporation: `Kakao Entertainment Corporation`,
  more_serviceinfo_business_name_representative: `Co-CEO`,
  more_serviceinfo_business_name_representative_detail: `Kisu Kweon, Joseph Chang`,
  more_serviceinfo_business_registration_number: `Nomor registrasi bisnis`,
  more_serviceinfo_business_registration_number_detail: `144-81-35088`,
  more_serviceinfo_business_mail_order: `Pemberitahuan dari email resmi`,
  more_serviceinfo_business_mail_order_detail: `2018-Seongnam Bundang B-0004`,
  more_serviceinfo_business_address: `Alamat`,
  more_serviceinfo_business_address_detail: `Gyeonggido Seognamsi Bundanggu Pangyo 221`,
  more_serviceinfo_business_phone: `Nomor telepon`,
  more_serviceinfo_business_phone_detail: `+82 1644-4755`,
  more_serviceinfo_business_email: `Alamat email`,
  more_serviceinfo_business_email_detail: `contact@kakaoent.com`,
  more_serviceinfo_business_host: `Penyedia layanan`,
  more_serviceinfo_version: `Informasi versi aplikasi`,
  more_serviceinfo_version_latest: `Versi terbaru`,
  more_serviceinfo_version_current: `Versi saat ini`,
  more_serviceinfo_version_update: `Update ke versi terbaru`,
  more_serviceinfo_version_latest_inuse: `Versi terbaru sedang digunakan`,
  more_serviceinfo_version_minsdk_change_title: `Tingkatkan versi minimum OS yang didukung`,
  more_serviceinfo_version_minsdk_change_content: `Untuk layanan yang lebih stabil dan lancar, versi OS minimum yang didukung dinaikkan menjadi {{value}}.

Aplikasi tidak bisa di perbarui di bawah versi {{value}} dan harap dipahami bahwa kedepannya layanan ini tidak dapat digunakan bila tidak upgrade OS kamu.
`,
  more_serviceinfo_version_minsdk_changed_title: `Penghentian dukungan versi lama`,
  more_serviceinfo_version_minsdk_changed_content: `Membaca episode yang dibeli dan melakukan refund tiket hanya bisa dilakukan pada situs website Kakao Webtoon.
Harap dipahami bahwa ini untuk memberikan layanan yang lebih stabil.`,
  more_serviceinfo_version_minsdk_changed_gotoweb: `Buka halaman Web`,
  redeem_coupon_before_enter: `Masukkan kode Kupon`,
  redeem_coupon_before_register_button: `Daftar `,
  redeem_coupon_policy: `Kebijakan Daftar Kupon`,
  redeem_coupon_inquiry: `Syarat Pengguna`,
  redeem_coupon_policy_detail_1: `Kupon yang kedaluwarsa tidak dapat didaftarkan.`,
  redeem_coupon_policy_detail_2: `Kupon tidak dapat di-refund`,
  redeem_coupon_policy_detail_3: `Cek masa kedaluwarsa Kupon pada 'Side Menu > Riwayat Cash'.`,
  redeem_coupon_policy_detail_3_v4: `Kamu dapat memeriksa hadiah yang diterima dari penukaran kupon di 'Side Menu > Notifikasi'.`,
  redeem_coupon_toast_success: `Pendaftaran kupon berhasil
Silakan cek di Notifikasi.`,
  redeem_coupon_toast_fail_invalid_checkagain: `Kode Kupon tidak valid. 
Silakan cek dan masukkan kembali.`,
  redeem_coupon_toast_fail_used: `Kode yang kamu daftarkan telah digunakan.`,
  redeem_coupon_toast_fail_sametype: `Kupon dengan tipe yang sama hanya berlaku satu kali.`,
  redeem_coupon_toast_fail_ineligible: `Kamu tidak dapat menggunakan Kupon ini`,
  redeem_coupon_toast_fail_expired: `Kupon sudah kedaluwarsa`,
  redeem_coupon_toast_fail_invalid: `Kupon tidak valid `,
  redeem_coupon_toast_fail_ranout: `Kuota pengisian kupon telah habis.`,
  redeem_coupon_toast_fail_used_device: `Kamu menukar kupon ini pada perangkat ini.`,
  settings_title: `Pengaturan`,
  settings_system_preferences: `Preferensi sistem`,
  settings_notifications: `Notifikasi`,
  settings_notifications_content: `Notifikasi dinonaktifkan.`,
  settings_notifications_device: `Notifikasi perangkat`,
  settings_notifications_device_detail: `Aktifkan notifikasi perangkat untuk menerima notifikasi`,
  settings_notifications_toast: `Berfungsi setelah notifikasi diaktifkan`,
  settings_notifications_aos_toast: `Tersedia setelah semua 
notifikasi diaktifkan`,
  settings_notifications_ios_popup: `Buka halaman pengaturan untuk
mengubah notifikasi perangkat.`,
  settings_notifications_marketing: `Notifikasi event dan 
rekomendasi karya`,
  settings_notifications_marketing_detail: `Izinkan notifikasi untuk rekomendasi dan event`,
  settings_notifications_marketing_detail_320: `Izinkan notifikasi untuk rekomendasi dan event`,
  settings_notifications_marketing_on_toast: `Notifikasi diaktifkan pada {{value}}`,
  settings_notifications_marketing_on_toast_320: `Notifikasi diaktifkan pada {{value}}`,
  settings_notifications_marketing_off_toast: `Notifikasi KAKAO WEBTOON dinonaktifkan pada {{value}}`,
  settings_notifications_marketing_off_toast_320: `Notifikasi KAKAO WEBTOON dinonaktifkan pada {{value}}`,
  settings_notifications_device_off: `Notifikasi perangkat tidak aktif.
\nHarap aktifkan notifikasi.`,
  settings_notifications_login_toast: `Tersedia setelah Masuk`,
  settings_notifications_updates: `Notifikasi saat episode update`,
  settings_notifications_updates_detail: `Dapatkan notifikasi untuk setiap episode yang update di favoritmu`,
  settings_notifications_ticket: `Notifikasi pada Tiket Tunggu Gratis`,
  settings_notifications_likes_comment_global: `Notifikasi pada komentar yang disukai`,
  settings_notifications_likes_reply_global: `Notifikasi pada komentar yang dibalas`,
  settings_notifications_likes_reply_global_320: `Notifikasi pada komentar yang dibalas`,
  settings_notifications_sleepmode_global: `Pengaturan sleepmode`,
  settings_notifications_sleepmode_global_info: `Tidak menerima notifikasi pada waktu yang telah ditentukan.`,
  settings_notifications_sleepmode_global_start: `Waktu dimulainya Sleepmode `,
  settings_notifications_sleepmode_global_end: `Waktu berakhirnya Sleepmode `,
  settings_notifications_sleepmode_global_pm: `{{time}} PM`,
  settings_notifications_sleepmode_global_am: `{{time}} AM`,
  settings_data: `Pengaturan data`,
  settings_data_wifi_view: `Baca dalam jaringan Wi-Fi`,
  settings_data_wifi_download: `Unduh episode hanya dalam jaringan Wi-Fi`,
  settings_autoplay: `Video autoplay`,
  settings_autoplay_on: `Aktifkan`,
  settings_autoplay_off: `Nonaktifkan`,
  login_register_device_popup: `Kamu harus Masuk untuk mendaftarkan perangkat`,
  settings_device_empty: `Tidak ada perangkat yang terdaftar`,
  settings_device_registered: `{{value}} perangkat terdaftar.`,
  settings_device_register: `Daftarkan perangkat`,
  settings_device_deregister: `Membatalkan pendaftaran perangkat`,
  settings_device_register_success_toast: `Perangkat terdaftar`,
  settings_device_register_fail_toast: `Pendaftaran perangkat gagal.
Silakan coba lagi.`,
  settings_device_registered_toast: `Perangkat ini telah terdaftar.`,
  settings_device_deregister_toast: `Perangkat yang dibatalkan pendaftarannya`,
  settings_device_register_continue_popup_title: `Apakah kamu yakin ingin melanjutkan pembatalan pendaftaran perangkat?`,
  settings_device_register_continue_popup_content: `Jumlah pembatalan pendaftaran untuk bulan ini akan dipotong.`,
  settings_device_register_impossible_popup: `Tidak dapat membatalkan pendaftaran perangkat karena jumlah pembatalan pendaftaran sudah terlampaui.`,
  settings_device_detail_1: `Pendaftaran perangkat diperlukan untuk mengunduh episode`,
  settings_device_detail_2: `Hanya dua perangkat per ID yang bisa didaftarkan.`,
  settings_device_detail_3: `Pembatalan pendaftaran perangkat hanya dapat dilakukan satu kali dalam sebulan. {{value}} kali tersisa.`,
  settings_device_detail_4: `Setelah melebihi batas pendaftaran perangkat, kamu dapat mendaftarkan/membatalkan pendaftaran perangkat pada hari pertama di bulan depan.`,
  settings_device_info_in_use_registered: `Perangkat yang terdaftar sedang digunakan`,
  settings_device_info_in_use_unregistered: `Perangkat yang belum terdaftar sedang digunakan .`,
  settings_device_registered_date: `Terdaftar pada {{date}}`,
  settings_device_info_deregister_button: `Pembatalan pendaftaran`,
  settings_tracking_ios: `Tracking`,
  settings_tracking_ios_popup: `Dapatkan lebih banyak notifikasi event dan hadiah melalui Tracking. Izinkan fitur Tracking?`,
  settings_tracking_on_ios_toast: `Ubah pengaturan pelacakan
di menu pengaturan dan izinkan pelacakan.`,
  settings_tracking_on_ios_oldversion_toast: `Berfungsi dalam versi iOS 14 ke atas.`,
  settings_language: `Pengaturan bahasa`,
  settings_language_popup_title: `Apakah kamu mau mengubah ke bahasa {{language}}?`,
  settings_language_popup_content: `Judul karya akan berubah mengikuti bahasa yang digunakan pada aplikasi.`,
  settings_language_popup_content_app: `Karya yang dapat dinikmati mungkin berbeda saat pengaturan bahasa diubah. Silakan mulai ulang aplikasi untuk menyelesaikan perubahan bahasa.`,
  settings_language_popup_content_web: `Karya yang dapat dinikmati mungkin berbeda saat pengaturan bahasa diubah.`,
  region_language_change_settings_popup: `Restart aplikasi untuk perubahan bahasa`,
  settings_manage_space: `Manajemen ruang penyimpanan`,
  common_stroage_used_kb: `<bold>{{used}} KB</bold> / {{max}} GB`,
  common_stroage_used_mb: `<bold>{{used}} MB</bold> / {{max}} GB`,
  common_stroage_used: `<bold>{{used}} GB</bold> / {{max}} GB`,
  settings_manage_space_delete_downloads_button: `Hapus semua unduhan`,
  settings_manage_space_delete_downloads_popup_title: `Apakah kamu yakin mau menghapus semua unduhan dari perangkatmu?`,
  settings_manage_space_delete_downloads_popup_content: `Menghapus berdasarkan judul dan episode bisa dilakukan pada menu 'Library > Unduhan'`,
  settings_manage_space_delete_cash_button: `Hapus cache`,
  settings_manage_space_delete_cash_toast: `Cache dihapus`,
  settings_manage_space_autodelete: `Pengaturan hapus otomatis`,
  settings_manage_space_autodelete_10d: `10 hari `,
  settings_manage_space_autodelete_popup_title: `Apakah kamu ingin mengubah periode hapus otomatis menjadi 10 hari?`,
  settings_manage_space_autodelete_popup_content: `Jika diubah, konten yang telah diunduh pada 10 hari yang lalu akan otomatis dihapus.`,
  settings_viewer: `Pengaturan viewer`,
  settings_viewer_sort: `Urutkan episode berdasarkan`,
  settings_viewer_sort_date: `Terbaru`,
  settings_viewer_sort_episode: `Tanggal`,
  settings_viewer_type: `Mode episode default`,
  settings_viewer_type_thumbnai: `Mode thumbnail`,
  settings_viewer_type_list: `Mode list`,
  settings_viewer_resolution: `Pengaturan resolusi viewer`,
  settings_viewer_resolution_high: `Tinggi`,
  settings_viewer_resolution_low: `Rendah`,
  settings_display_mode: `Tema tampilan layar`,
  settings_display_mode_dark: `Mode Gelap`,
  settings_display_mode_light: `Mode Terang`,
  settings_display_mode_system: `Pengaturan sistem`,
  login_auto_toast: `Masuk otomatis
Silakan coba beberapa saat lagi`,
  login_adult_toast: `Konten ini tidak diperuntukkan bagi remaja.`,
  login_popup: `Tersedia setelah Masuk`,
  login_action_adult_popup: `Kamu harus Masuk untuk
membaca konten dewasa`,
  login_action_view_gidamu_episode_popup: `Kamu harus Masuk untuk
membaca episode Tunggu Gratis`,
  login_action_view_next_ep_popup: `Kamu harus Masuk untuk 
membaca episode berikutnya`,
  deleted_account_popup: `Tidak bisa mendaftar ulang dengan akun yang sama dalam waktu 30 hari setelah menghapus akun.`,
  inactive_user_popup_title: `Silakan aktifkan akun kamu untuk menggunakan akun kamu kembali.`,
  inactive_user_popup_content: `Akun ini sudah tidak aktif selama 1 tahun.
Untuk melindungi informasi pribadi, akun ini
telah di non-aktifkan. Klik oke untuk mengkatifkan akun kamu kembali.`,
  blocked_user_popup_title: `Masuk diblokir karena kebijakan operasional`,
  blocked_user_popup_content: `Silakan hubungi Customer Service kami untuk melaporkan kendala`,
  blocked_user_popup_content_cs: `Kontak <link_cs> Customer Service</link_cs>`,
  new_user_login_popup_web: `Pengguna baru KAKAO WEBTOON?
Daftar di aplikasi dan dapatkan hadiah.`,
  new_user_login_popup_button_web: `Daftar di aplikasi`,
  new_user_login_popup_continue_web: `Lanjutkan`,
  login_global_onboarding_popup: `Daftar/Masuk untuk menjelajahi KAKAO WEBTOON`,
  login_global_gidamu_popup: `Daftar/Masuk untuk membaca episode 'Tunggu Gratis'`,
  login_global_popup: `Silakan Masuk untuk menikmati layanan`,
  login_global_existing_account_popup: `Kamu pernah Masuk dengan {{existing}} `,
  login_global_account_google: `Masuk dengan Google`,
  login_global_account_apple: `Masuk dengan Apple`,
  login_global_account_facebook: `Masuk dengan Facebook`,
  login_global_account_line: `Masuk dengan LINE`,
  login_global_account_twitter: `Masuk dengan Twitter`,
  login_global_existing_other_option_button: `Masuk dengan opsi lainnya`,
  login_global_existing_different_signin_button: `Masuk dengan akun berbeda`,
  login_global_create_account_popup: `Buat akun untuk melanjutkan`,
  login_global_have_account_popup: `Sudah punya akun?`,
  login_signin_button: `Masuk`,
  login_signup_page_title: `Syarat dan ketentuan`,
  login_signup_description_title: `Daftar KAKAO WEBTOON`,
  login_signup_description_content: `dan nikmati cerita yang tak terbatas!`,
  login_signup_agree_all: `Setujui semua`,
  login_new_signup_button: `Daftar KAKAO WEBTOON`,
  login_global_signup_agree_termsofuse: `Saya telah membaca dan menyetujui ketentuan penggunaan. <grey>(wajib)</grey>`,
  login_global_signup_termsofuse_page_title: `Syarat Penggunaan`,
  login_global_signup_agree_privacy: `Saya telah membaca dan menyetujui kebijakan privasi. <grey>(wajib)</grey>`,
  login_global_signup_privacy_page_title: `Kebijakan Privasi`,
  login_global_signup_agree_data_transfer: `Saya setuju dengan transfer informasi pribadi internasional. (Lihat Kebijakan Privasi untuk detailnya.) <grey>(wajib)</grey>`,
  login_global_signup_agree_age: `Saya berusia di atas 18 tahun. <grey>(wajib)</grey>`,
  login_global_signup_agree_required_sentence: `Mohon menyetujui ketentuan di atas untuk mendaftar.`,
  login_another_device_popup: `Akunmu telah Masuk menggunakan perangkat lain. Apakah kamu mau Keluar dari perangkat lain dan Masuk dengan perangkat ini?`,
  login_global_signedup_web: `Akun ini telah terdaftar di negara lain. Apakah kamu bersedia untuk pergi ke laman website di negara yang kamu ikuti?`,
  login_global_signedup_web_button: `Pergi ke website`,
  login_global_signedup_app: `Perubahan bahasa akan terjadi karena negara yang dipilih saat mendaftar berbeda dari negara saat ini. Silakan mulai ulang aplikasi.`,
  login_global_signedup_app_button: `Restart`,
  login_global_signedup_region_popup: `Akun yang sedang kamu daftarkan adalah akun untuk wilayah saat ini {{region}}. Apakah kamu yakin ingin beralih ke layanan di wilayah kamu? Aplikasi akan ditutup jika wilayah berubah.`,
  login_global_signedup_region_popup_button: `Ubah negara`,
  region_country_select_taiwan: `台灣`,
  region_country_select_thailand: `ไทย`,
  region_country_select_france: `France`,
  region_country_select_indonesia: `Indonesia`,
  region_country_select_korea: `한국`,
  login_forced_logout_popup: `Kamu telah Keluar dari layanan karena kamu Masuk dengan perangkat lain.`,
  login_restricted_popup_title: `Daftar dan Masuk ke akun baru dilarang untuk sementara waktu.`,
  login_restricted_popup_content: `Kamu tidak dapat mendaftar karena telah terdeteksi menggunakan beberapa akun pada perangkat ini.
Silakan gunakan akun sebelumnya. Bila ingin mendaftar akun baru silakan hubungi CS`,
  login_restricted_help_popup: `Butuh bantuan? <bold-link_cs>Hubungi kami</bold-link_cs>`,
  login_adult_verify_popup: `Konten ini tidak diperuntukkan bagi remaja. Apakah kamu berusia lebih dari 18 tahun?`,
  error_code_3000_toast: `Silakan masuk lagi Untuk memperbarui informasi autentikasi akun,`,
  login_blocked_toast: `Kamu terlalu sering mencoba untuk Masuk. Untuk melindungi akunmu, ada penangguhan sementara saat Masuk. Silakan coba lagi nanti.`,
  login_global_withdraw_consent_popup_title: `Ini adalah akun untuk pencabutan persetujuan terhadap syarat dan ketentuan.`,
  login_global_withdraw_consent_popup_content: `Syarat dan ketentuan penggunaan di cabut berdasarkan permintaan pengguna.
Kamu akan keluar dan ketika masuk kamu membutuhkan persetujuan syarat dan penggunakan.`,
  login_global_reconsent_title: `Harap setujui syarat dan ketentuan penggunaan
 KAKAO WEBTOON.`,
  authentication_global_popup_title: `Masukkan tanggal lahir untuk membaca konten.`,
  authentication_global_popup_content: `Karya ini berisi konten yang tidak sesuai untuk anak di bawah umur. Oleh karena itu, ini hanya dapat dilihat oleh orang yang berusia di atas 18 tahun. Harap masukkan tanggal lahir Anda untuk memverifikasi usia Anda.`,
  authentication_global_adult_toast: `BIsa dibaca untuk usia diatas 18 tahun.`,
  authentication_global_succeed_adult_toast: `Terverifikasi umur {{n}} tahun.`,
  authentication_global_failed_adult_toast: `Karya ini dapat dibaca untuk umur diatas 18 tahun.`,
  authentication_global_confirm_popup_content: `(번역 필요)`,
  luckydraw_title_slot: `Lucky Slot Machine `,
  luckydraw_title_box: `Lucky Gift`,
  luckydraw_title_web: `Lucky Draw`,
  luckydraw_start: `Mulai`,
  luckydraw_win: `Memenangkan hadiah`,
  luckydraw_win_prize: `Memenangkan hadiah`,
  luckydraw_participated: `Kamu sudah ikut berpartisipasi`,
  luckydraw_winning_gift: `Hadiah`,
  luckydraw_date_received: `Tanggal diterima`,
  luckydraw_expiry: `Kedaluwarsa`,
  luckydraw_expiry_date: `{{count}} hari setelah tanggal diterima`,
  luckydraw_expiry_date_plural: `{{count}} hari setelah tanggal diterima`,
  luckydraw_expiry_hour: `{{count}} jam setelah tanggal diterima`,
  luckydraw_expiry_hour_plural: `{{count}} jam setelah tanggal diterima`,
  luckydraw_expiry_specific: `sampai {{value}}`,
  luckydraw_expiry_today: `Hari ini`,
  luckydraw_expiry_hour_1: `59 menit dari sekarang.`,
  luckydraw_expired: `Lucky Slot Machine 
Periode event telah berakhir.`,
  luckydraw_expired_box: `Lucky Gift Box
Periode event telah berakhir`,
  luckydraw_win_cash: `Memenangkan Cash`,
  luckydraw_win_cash_amount: `Kamu mendapat {{value}} Cash`,
  luckydraw_ticket_title: `Judul`,
  luckydraw_win_ticket_amount: `Kamu mendapat {{count}} Tiket Hadiah`,
  luckydraw_win_ticket_amount_plural: `Kamu mendapat {{count}} Tiket Hadiah`,
  luckydraw_prize_notice: `Pemberitahuan`,
  luckydraw_prize_notice_1: `Tidak bisa mengubah informasi yang telah dikirimkan.`,
  luckydraw_prize_notice_2_specific: `Hadiah akan dibatalkan jika data diri tidak dikirimkan hingga {{date}}`,
  luckydraw_prize_notice_2: `Hadiah akan dibatalkan jika data diri pemenang tidak dikirimkan sampai {{date}} sejak hari pemenang hadiah diumumkan.`,
  luckydraw_prize_notice_3: `Kami akan segera menghubungi untuk meminta data diri. Hadiah akan batal bila memasukkan informasi yang tidak sesuai.`,
  luckydraw_global_enterinfo: `Isi Data Diri`,
  luckydraw_global_title: `Isi Data Diri`,
  luckydraw_global_enterinfo_prize: `Untuk mengklaim {{prize}}, masukkan data dirimu.`,
  luckydraw_global_enterinfo_placeholder: `Silakan masukkan data diri.`,
  luckydraw_global_enterinfo_button_submit: `Kirimkan`,
  luckydraw_global_enterinfo_button_expired: `Kedaluwarsa`,
  luckydraw_global_enterinfo_button_submitted: `Terkirim`,
  luckydraw_global_entered_popup: `Data dirimu sudah terkirim.`,
  crm_ticker_button: `Cek Sekarang!`,
  crm_bottom_event_period: `Event`,
  crm_bottom_reward_title: `Reward`,
  crm_bottom_notice: `Pemberitahuan`,
  crm_comment_button: `Tulis komentar`,
  crm_comment_count: `Lihat {{count}} komentar`,
  crm_comment_count_plural: `Lihat {{count}} komentar`,
  crm_advance_reservation_button: `Daftar pra-registrasi`,
  crm_advance_reservation_toast: `Pra-registrasi selesai`,
  crm_advance_reservation: `Pra-registrasi`,
  crm_advance_reservation_button_v4: `Daftar`,
  crm_attendance_status_count: `Kehadiran {{count}}/{{max}} `,
  crm_attendance_status_not_participated: `SIap `,
  crm_attendance_status_participating: `Ongoing`,
  crm_attendance_status_participated: `Telah diikuti`,
  crm_attendance_status_toast: `Kehadiran`,
  crm_attendance_status_day: `Day {{value}} check in`,
  crm_attendance_status_day_v4: `Hari {{value}} `,
  crm_attendance_status_day_short: `Day {{value}} check in`,
  crm_attendance_reward_slot_ticket: `Reward Tiket Slot Machine Draw!`,
  crm_attendance_reward_gift_ticket: `Reward Tiket Hadiah!`,
  crm_attendance_reward_cash: `Reward {{value}} Cash`,
  crm_attendance_button_before: `Check-in`,
  crm_attendance_button_complete: `Check-in Komplet`,
  crm_attendance_advance_register: `Daftar Pre-Registrasi `,
  crm_attendance_advance_register_button: `Daftar`,
  crm_attendance_advance_registered_toast: `Daftar Pre-Registrasi telah selesai.`,
  crm_attendance_advance_register_button_before: `Daftar Pre-Registrasi `,
  crm_attendance_advance_register_button_after: `Pre-Registrasi selesai`,
  crm_push_mission_title: `Misi PUSH Notif`,
  crm_push_mission_content: `Aktifkan PUSH Notif untuk menerima update event`,
  crm_push_on_toast: `PUSH Notif telah diaktifkan`,
  crm_push_on: `Aktifkan PUSH Notif`,
  crm_push_on_button: `Aktifkan`,
  crm_fav_notification_popup_title: `Telah ditambahkan ke Favoritku`,
  crm_fav_notification_popup_content: `Kamu akan menerima notifikasi ketika episode baru rilis.
Notifikasi dapat diatur di 'Library > Favoritku'.`,
  crm_recommend_not_sale: `Karya ini belum dirilis. Silakan coba lagi nanti.`,
  crm_quiz_before_enter: `Masukkan jawaban`,
  crm_quiz_submit_button: `Kirimkan`,
  crm_quiz_submit_complete_button: `Terkirim`,
  crm_quiz_correct_answer_popup: `Jawabanmu benar!
{{reward}} telah ditambahkan ke akunmu.`,
  crm_quiz_correct_answer_raffle_popup: `Jawabannya benar!
`,
  crm_quiz_incorrect_answer_popup: `Jawabanmu masih salah.
Coba lagi, ya.`,
  crm_quiz_hint: `HINT`,
  crm_quiz_answer_exceed_toast: `Jumlah karakter melebihi jumlah karakter yang bisa ditulis.`,
  crm_share_button: `Bagikan Event`,
  share_invitation_code_popup: `Bagikan Kode Undangan ke teman`,
  special_title: `Special`,
  mainhome_special_contenthome_button: `Kembali ke halaman karya`,
  mainhome_popup_version_update_mandatory_title: `Pemberitahuan Himbauan Update`,
  mainhome_popup_version_update_mandatory_content: `Himbauan untuk meng-update ke versi terbaru. Update biasanya membutuhkan waktu sekitar 1 menit, dan setelah itu kamu dapat menikmati layanan tanpa kendala.`,
  mainhome_popup_version_update_optional_title: `Update`,
  mainhome_popup_version_update_optional_content: `Update ke versi terbaru akan menjaga fungsi Kakao Webtoon lebih stabil. Update biasanya membutuhkan waktu sekitar 1 menit, dan setelah itu kamu dapat menikmati layanan tanpa kendala.`,
  mainhome_popup_permission_title: `Izin Aplikasi Kakao Webtoon`,
  mainhome_popup_permission_content: `Kamu perlu memberi izin beberapa akses saat menggunakan aplikasi.`,
  mainhome_popup_version_keep_button: `Tetap di versi saat ini`,
  mainhome_popup_version_exit_button: `Keluar`,
  mainhome_popup_participate_button: `Ikut`,
  mainhome_popup_dontshow_button: `Jangan tampilkan lagi`,
  mainhome_popup_view_detail_button: `Lihat rincian`,
  mainhome_popup_more_button: `Lihat lebih banyak`,
  error_server_toast: `Gagal memuat data.`,
  error_server_popup_request: `Saat ini kami belum bisa memproses permintaanmu. Silakan coba kembali.`,
  mainhome_popup_idfa_ko: `Pilih 'izinkan' untuk hanya menampilkan iklan yang cocok untukmu. 
Jika kamu tidak memberi izin, iklan akan ditampilkan secara acak.`,
  mainhome_popup_idfa_global: `Datamu diatur untuk memberikan
pengalaman iklan yang personal dan lebih baik.`,
  mainhome_display_mode_popup_title: `Sekarang kamu dapat memilih mode tampilan layar, cobalah!`,
  mainhome_display_mode_popup_content: `Kamu dapat memilih mode tampilan layar pilihanmu di antara mode gelap atau mode terang.`,
  mainhome_display_mode_popup_button: `Ke pengaturan`,
  badge_new: `N`,
  badge_up: `UP`,
  badge_today: `Today`,
  badge_new_season: `N`,
  badge_ongoing: `Ongoing`,
  badge_completed: `End`,
  badge_hiatus: `Hiatus`,
  badge_completed_season: `End Season`,
  badge_brand: `Brand Webtoon`,
  badge_alive: `ALIVE`,
  badge_mon: `Sen`,
  badge_tue: `Sel`,
  badge_wed: `Rab`,
  badge_thu: `Kam`,
  badge_fri: `Jum`,
  badge_sat: `Sab`,
  badge_sun: `Min`,
  badge_not_available: `Penjualan dihentikan`,
  badge_mon_long: `Sen`,
  badge_tue_long: `Sel`,
  badge_wed_long: `Rab`,
  badge_thu_long: `Kam`,
  badge_fri_long: `Jum`,
  badge_sat_long: `Sab`,
  badge_sun_long: `Min`,
  badge_free: `Gratis`,
  badge_rent: `Sewa`,
  badge_possess: `Beli`,
  badge_comment_creator: `Kreator`,
  badge_comment_best: `BEST`,
  onboarding_next_button: `Berikutnya`,
  onboarding_start_button: `Mulai`,
  onboarding_start_without_login: `Mulai tanpa Masuk`,
  onboarding_start: `Halo, selamat datang di KAKAO WEBTOON.`,
  onboarding_skip_popup_title: `Tunggu! Welcome voucher sudah menunggu untuk pengguna baru.`,
  onboarding_skip_popup_content: `Gabung sekarang untuk menerima Tiket Gratis untuk karya rekomendasi.`,
  onboarding_skip_comfirm: `Ke Halaman Utama`,
  onboarding_genre_title: `Pilih genre yang kamu suka dan kami akan rekomendasikan karya yang sesuai denganmu.`,
  onboarding_content_title: `Selamat! Kamu menerima Tiket Gratis KAKAO WEBTOON. `,
  bridgepage_description: `Ayo temukan cerita yang 
dapat membangkitkan imajinasimu 
di KAKAO WEBTOON`,
  bridgepage_web_button: `Lanjut baca di web`,
  bridgepage_app_button: `Lanjut baca di app`,
  bridgepage_language_change: `Terjadi kesalahan akses karena pengaturan bahasa.
Silakan periksa pengaturan bahasamu dan coba lagi.`,
  error_network_popup_ios: `Tidak dapat menjalankan aplikasi. Silakan coba lagi.`,
  offline_no_connection_popup: `Kamu sedang tidak terhubung ke jaringan internet. Apakah kamu mau mengganti ke mode offline?`,
  offline_no_connection_popup_exit_button: `Keluar dari aplikasi`,
  error_api_call_toast: `Tidak bisa memproses permintaanmu. Silakan coba lagi.`,
  offline_enter_button: `Masuk ke mode offline`,
  offline_no_connection_toast: `Kamu tidak terhubung dengan jaringan. Silakan cek koneksi jaringanmu.`,
  offline_convert_online_popup: `Kamu terhubung dengan jaringan. Apakah kamu mau beralih ke mode online?`,
  offline_enter_online_mode: `Mode online`,
  offline_download_tab_title: `Unduh`,
  offline_rental_expired_toast: `Masa berlaku Tiket Sewa telah berakhir.`,
  error_region_unmatch_app_popup: `Layanan ini tidak tersedia di negara ini.
Silakan instal ulang aplikasi dan klik negara yang seusai untuk terus menggunakan layanan ini.`,
  error_region_unmatch_web_popup: `Layanan tidak tersedia di negara ini.
Silakan instal ulang aplikasi dan klik negara yang seusai untuk terus menggunakan layanan ini.`,
  error_server_common_toast: `Terjadi kendala. Silakan coba kembali.`,
  error_server_duplicate_request_toast: `Permintaan sedang diproses`,
  error_version_popup_contents: `Fungsi yang telah diminta belum tersedia pada versi saat ini. Silakan update aplikasimu ke versi terbaru melalui App Store.`,
  error_page_not_found: `Halaman yang kamu inginkan tidak dapat ditemukan.`,
  error_not_found: `Halaman yang diminta tidak dapat ditemukan.`,
  block_service_check_title: `Pemberitahuan Pemeliharaan Layanan`,
  block_service_check_content: `Demi memberikan layanan yang lebih cepat dan lancar, kami akan melakukan pemeriksaan layanan selama waktu berikut. Terima kasih atas pengertiannya.`,
  block_service_check_date_range: `Periode pemeriksaan {{start}} ~ {{end}}`,
  error_event_expired_popup: `Event ini sudah berakhir.`,
  error_event_expired_toast: `Tidak dapat berpartisipasi dalam event karena periode sudah berakhir.`,
  error_event_participate_popup: `Tidak dapat mengikuti event.`,
  error_cash_fail_aos: `Terjadi error di Google Play saat transaksi diproses. Silakan clear data dan cache dari Google Play Store dan coba kembali.`,
  error_cash_fail_aos_button: `Hapus dari pengaturan`,
  android_tampering_popup_title: `Terdeteksi gangguan aplikasi.`,
  android_tampering_popup_content: `Bila masih mengalami gangguan yang sama setelah mengunduh ulang aplikasi silakan hubungi CS.`,
  android_error_connection: `Halaman tidak dapat dimuat. Harap periksa koneksi jaringanmu dan coba lagi.`,
  android_error_temporary: `Halaman tidak dapat dimuat karena terjadi masalah sementara.`,
  android_error_webview: `Terjadi masalah di tampilan web. 
Silakan coba kembali`,
  js_alert_leave_title: `Konfirmasi Survei`,
  leave_this_page: `Tinggalkan halaman ini`,
  stay_this_page: `Tetap di halaman ini`,
  question_leave_this_page: `Apakah kamu yakin akan meninggalkan halaman ini?`,
  ssl_warnings_header: `Terjadi kesalahan pada sertifikat keamanan website.`,
  ssl_continue: `Lanjutkan`,
  security_warning: `Peringatan keamanan`,
  view_certificate: `Lihat sertifikat`,
  ssl_go_back: `Kembali`,
  android_back_button_quit_toast: `Tap tombol kembali sekali lagi untuk keluar.`,
  ssl_untrusted: `Sertifikat tidak dikeluarkan oleh otoritas sertifikasi tepercaya.`,
  ssl_mismatch: `Nama website tidak sesuai dengan sertifikat.`,
  ssl_expired: `Sertifikat telah kedaluwarsa.`,
  ssl_not_yet_valid: `Sertifikat tidak dapat ditemukan.`,
  ssl_date_invalid: `Sertifikat belum divalidasi.`,
  ssl_invalid: `Sertifikat tidak valid`,
  ssl_unknown: `Terjadi kesalahan yang tidak diketahui pada sertifikat.`,
  ssl_certificate: `Sertifikat keamanan`,
  ssl_certificate_is_valid: `sertifikat valid`,
  page_info: `Informasi halaman`,
  page_info_view: `Lihat Informasi halaman`,
  page_info_address: `Alamat:`,
  issued_to: `Diterbitkan untuk:`,
  common_name: `Nama:`,
  org_name: `Nama organisasi:`,
  org_unit: `Unit organisasi:`,
  issued_by: `Dikeluarkan oleh:`,
  validity_period: `Tipe:`,
  issued_on: `Tanggal terbit:`,
  expires_on: `Kedaluwarsa pada:`,
  serial_number: `Nomor serial:`,
  sha256_fingerprint: `Sidik jari SHA-256:`,
  sha1_fingerprint: `Sidik jari SH-1:`,
  message_webview_certificate_transparency: `Mohon perbarui aplikasi yang terkait dengan tampilan website untuk menyelesaikan masalah sertifikat keamanan.`,
  popup_window_attempt: `Izinkan pop up pada situs ini?`,
  webview_allow: `Izinkan`,
  webview_block: `Blokir`,
  webview_update: `Update`,
  webview_ok: `Oke`,
  webview_cancel: `Batal`,
  webview_login: `Masuk`,
  js_alert_title: `'{{value}}' halaman konten:`,
  notification_category_download: `Unduh`,
  notification_category_common: `Pemberitahuan umum`,
  notification_channel_download: `Notifikasi untuk unduh episode `,
  notification_channel_common: `Notifikasi untuk episode update, tunggu gratis, dan event.`,
  android_battery_optimization_popup_contents: `Jika Anda ingin mengunduh episode saat berada di latar belakang, Anda perlu menonaktifkan aplikasi kakao webtoon dari pengaturan pengoptimalan baterai.`,
  multilingual_redeem_code_popup: `Kupon ini tidak dapat digunakan dalam pengaturan bahasa ini.`,
  footer_customer_service: `Customer Service`,
  footer_business_info: `Informasi Bisnis`,
  footer_terms_of_use: `Ketentuan Penggunaan`,
  footer_privacy: `Kebijakan Privasi`,
  footer_inquiry: `Hubungi kami`,
  footer_youth_protection: `Kebijakan Perlindungan Anak di Bawah Umur`,
  footer_copyright: `© KAKAO WEBTOON`,
  footer_cookie_policy: `Kebijakan Cookie`,
  region_unsupported_title: `Informasi Negara yang Tidak Mendukung Layanan`,
  region_unsupported_content: `Negara tempatmu terhubung saat ini tidak mendukung layanan. Pilih negara untuk menggunakan layanan kami. Setelah kamu memilih negara, kamu tidak dapat mengubahnya lagi.`,
  region_unsupported_exit_button: `Keluar dari aplikasi`,
  region_country_select: `Pilih negara`,
  region_country_select_english: `English`,
  region_language_different_popup: `Restart aplikasi untuk mengubah
bahasa yang tersedia di negara saat ini.`,
  region_restart_button: `Restart`,
  region_language_select_popup: `Silakan pilih bahasa untuk menggunakan layanan.`,
  region_language_restart_toast: `Mohon restart aplikasi untuk perubahan ke bahasa yang didukung di lokasi saat ini.`,
  region_select_region_popup_title: `Pilih Negara`,
  region_select_region_popup_title_v4: `Pilih Negara`,
  region_select_region_popup_content: `Mohon pilih negara untuk menggunakan layanan.
Ingatlah bahwa pemilihan negara tidak dapat diubah setelahnya.`,
  region_select_region_popup_content_v4: `Mohon pilih negara untuk menggunakan layanan.
Ingatlah bahwa pemilihan negara tidak dapat diubah setelahnya.`,
  invitation_guest_welcome_popup_title: `Selamat datang di KAKAO WEBTOON`,
  invitation_host_status_count: `mengundang {{count}}/{{max}} orang`,
  invitation_host_status_participating: `Ongoing`,
  invitation_host_status_participated: `Telah diikuti`,
  invitation_host_link_share_button: `Bagikan kode undangan`,
  invitation_host_link_share_popup_title: `Bagikan`,
  invitation_host_link_share_popup_content: `Bagikan Kode Undangan ke teman`,
  invitation_host_code_share_button: `Salin Kode Undangan`,
  invitation_host_code_share_toast: `Kode Undangan: {{code}} 
Kode telah disalin ke clipboard.`,
};